//GLOBAL - components from npm
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import toast, { Toaster as ToasterSecond } from "react-hot-toast";
import Moment from "moment";
import MicroModal from "micromodal";
import b2cauth from "react-azure-adb2c";
import ReactHtmlParser from "react-html-parser";

//SERVICES - api, conectors...
import {
  menuToggle,
  InsertPausaDB,
  UpdateRgBlock,
  UpdateInRgBlock,
  InsertRgBlock,
  LogoutIn,
  createStatusAgent,
  GetIpCurrent,
  createTimeStatusAgent,
  ActionIdleSocket,
  UpdateByeAttendant,
  deleteListCallQueue,
  clearReturnClient,
  returnListCallQueue,
  ShowVisibleNextAtd,
  InsertPauseSocketAction,
  ShowInfoDisplay,
  RemoveRemoteNotifier,
  AlterScreen,
  UpdateByeAttendantDis,
  UpdatePauseFutureRV,
  BlockFuture,
  ChangeAudioInteraction,
  ChangeAudioMessage,
  Nc2BlockUser,
  removeAtdUnique,
  RemoveAtd,
  changeBlockStatus,
  getAutomaticPause,
  AutomaticPause,
  getDeviceMicrofone,
  getDeviceAudio,
  getDeviceRing,
  AuthLoginChangePass,
  ConnectionsAPI,
  ChangeAudioCall,
  startCallActive,
  startCallHidden,
  setIsOpenFaqDragable,
  getFreeAgentsById,
  UpdateUserLoginResponse,
  setIsFuturePauseActive,
} from "../actions";
import { SendSocketClearReturn, CaptureCallSocket } from "../actions/websocket";
import {
  Popover,
  PopoverHeader,
  Tooltippy,
  PopoverNotifier,
} from "../actions/Tippy";
import { webphone_api } from "../actions/webphone_api";
import { nc2Service } from "../actions/nc2service";
import { event } from "jquery";

//ASSETS - icons, images...
import ResetPassword from "../build/images/report/reset-pass.svg";
import PAUSAERRADA from "../build/images/pausa-errada.png";
import SAIRLIVRE from "../build/images/livre.png";
import EMATENDIMENTO from "../build/images/em-atendimento.png";
import CLIENTE from "../build/images/user.svg";
import Logo from "../build/images/logo_ingweb.svg";
import LogoDark from "../build/images/logo_ingwebDark.svg";
import LogoSmarters from "../build/images/logo_smarters.svg";
import LogoDarkSmarters from "../build/images/logo_smartersDark.svg";
import { ReactComponent as IconClose } from "../build/images/closecircle22px.svg";
import { ReactComponent as DangerIcon } from "../build/images/dangericonred.svg";
import { ReactComponent as SettingsIcon } from "../build/images/setting-2.svg";
import { ReactComponent as CallIncomingIcon } from "../build/images/call-incoming.svg";
import { ReactComponent as NotificationIcon } from "../build/images/notification.svg";
import { ReactComponent as ArrowDown } from "../build/images/arrow_down.svg";
import { ReactComponent as ChangeUsernameIcon } from "../build/images/infouser-icons/frame.svg";
import { ReactComponent as ChangePasswordIcon } from "../build/images/infouser-icons/key.svg";
import { ReactComponent as LogoutIcon } from "../build/images/infouser-icons/logout.svg";
import { ReactComponent as ChangePictureIcon } from "../build/images/infouser-icons/profile-circle.svg";
import { ReactComponent as MicrophoneIcon } from "../build/images/microphone-2.svg";
import { ReactComponent as HeadphoneIcon } from "../build/images/headphone.svg";
import { ReactComponent as AllNotifIcon } from "../build/images/export.svg";
import { ReactComponent as TarefasIcon } from "../build/images/clipboard-tick.svg";
import { ReactComponent as EyeIcon } from "../build/images/eye.svg";
import { ReactComponent as EyeSlashIcon } from "../build/images/eye-slash.svg";
import { ReactComponent as FuturePauseIcon } from "../build/images/pause-circle.svg";
import { ReactComponent as CheckSucessIcon } from "../build/images/tick-circle.svg";
import { ReactComponent as CentroInferior } from "../build/images/position-popup/centro-inferior.svg";
import { ReactComponent as CentroSuperior } from "../build/images/position-popup/centro-superior.svg";
import { ReactComponent as InferiorDireito } from "../build/images/position-popup/inferior-direito.svg";
import { ReactComponent as InferiorEsquerdo } from "../build/images/position-popup/inferior-esquerdo.svg";
import { ReactComponent as SuperiorDireito } from "../build/images/position-popup/superior-direito.svg";
import { ReactComponent as SuperiorEsquerdo } from "../build/images/position-popup/superior-esquerdo.svg";
import { ReactComponent as IconRecuseCall } from "../build/images/infouser-icons/call.svg";
import { ReactComponent as UserEdit } from "../build/images/infouser-icons/user-edit.svg";
import { ReactComponent as IconMute } from "../build/images/infouser-icons/volume-slash.svg";
import { ReactComponent as IconAnswerCall } from "../build/images/attendanceIcons/call-calling.svg";

//COMPONENTS
import TimeCounter from "../containers/TimeCounter";
import TimeCounterFuture from "../containers/TimeCounterFuture";
import Automatic_pause from "./Automatic_pause";
import AddUserMidia from "./AddUserMidia";
import MountTabulator from "../containers/MountTabulator";
import Checkbox from "../components/manager-section/CheckboxIng/CheckboxIng";
import UserPhoto from "../components/UserPhoto/userphoto";
import TeamModal from "../modals/TeamModal";
import NotifierModal from "../modals/NotifierModal";

//STYLES
import "../build/css/header.css";
import ReconnectModal from "../components/ReconnectModal";
import SelectTagV2 from "../components/SelectTagV2/SelectTagV2";
import { previusMessagesService } from "./PreviousMessages/utils/PreviusMessagesService";
import { reqServiceSingleton } from "../utils/reqServices";
import { autoAsnwerCallbackServiceSingleton } from "../utils/autoAsnwerCallbackService";
import { voiceService } from "../utils/voiceService";
import { reconnectionHandler } from "../utils/reconnectionHandler";
import { noReadHandler } from "../utils/noReadHandler";

const { connection_platform } = require("../services/api");
const md5 = require("md5");

var datalogin = Moment().format("DD/MM/YYYY HH:mm");
var logoCarregada = Logo;
var nc2Enable = false;
var activeCall = false;
var keycount = 1;
var gethostname = window.location.hostname;
var pathname = "";
const iplocal = connection_platform.ip_intern;

if (
  gethostname === "localhost" ||
  connection_platform.ip_intern === gethostname
)
  pathname = iplocal;
else pathname = gethostname;
if (connection_platform.client_differentip === true)
  pathname = connection_platform.ip_extern;

function saveToStorage(value) {
  localStorage.setItem("aviso_sonoro_interacao", value);
}

function saveToStorageMsg(value) {
  localStorage.setItem("aviso_sonoro_mensagem", value);
}

function saveToStorageCall(value) {
  localStorage.setItem("aviso_sonoro_chamada", value);
}

function generateResult(idinput, device) {
  var slider = document.getElementById(idinput);

  var percentage =
    (100 * (slider.value - slider.min)) / (slider.max - slider.min);
  var bg = `linear-gradient(90deg, #455CC7 ${percentage}%, #BFC3CA ${
    percentage + 0.1
  }%)`;
  webphone_api.setvolume(device, percentage);
  slider.style.background = bg;
  if (slider.value > 100) {
    var bg = `linear-gradient(90deg, #ea1c18 ${percentage}%, #d7dcdf ${
      percentage + 0.1
    }%)`;
    slider.style.background = bg;
  }
}

const closeToast = () => {
  toast.remove();
};

const mapDispatchToProps = (dispatch) => {
  return {
    expMenu: (post) => {
      dispatch(menuToggle(post));
    },
    nc2Disabled: () => {
      dispatch(Nc2BlockUser(false, "Remover bloqueio do nc2"));
    },
    handleNextPauseAutomatice: () => {
      dispatch(AutomaticPause(dispatch));
    },
    exSTPausaDB: (post, status) => {
      dispatch(InsertPausaDB(post, status));
    },
    exInsertRgBlock: (post, pausa, justificativa) => {
      InsertRgBlock(post, pausa, justificativa)(dispatch);
    },
    exUpdateRgBlock: (post) => {
      UpdateRgBlock(post)(dispatch);
    },
    ShowInfoDisplay2: (post) => {
      dispatch(startCallHidden(12, "71982718640", undefined));
    },
    exUpdateInRgBlock: (
      post,
      pausa,
      justificativa,
      idpausaanterior,
      idserviceslogin,
      agent,
      logout,
    ) => {
      UpdateInRgBlock(
        post,
        pausa,
        justificativa,
        idpausaanterior,
        idserviceslogin,
        agent,
        logout,
      )(dispatch);
    },
    exLogoutIn: (post, servicesid, statusagent) => {
      dispatch(LogoutIn(post, servicesid, statusagent));
    },
    AlterStatus: (data, reason, idpausa, logout) => {
      dispatch(
        createStatusAgent(
          data,
          reason,
          Moment().format("DD/MM/YYYY HH:mm:ss"),
          idpausa,
          logout,
        ),
      );
    },
    createTimeStatusAgentIn: (post) => {
      dispatch(createTimeStatusAgent(post));
    },
    IdleSocketIn: (
      infousers,
      pausa,
      datalogin,
      idpausa,
      status,
      statusagent,
    ) => {
      dispatch(
        ActionIdleSocket(
          infousers,
          pausa,
          datalogin,
          idpausa,
          status,
          statusagent,
        ),
      );
    },
    UpdateServiceAtd: (serviceatd) => {
      dispatch(UpdateByeAttendantDis(serviceatd));
    },
    RemoveCallQueueReturn: (post) => {
      dispatch(deleteListCallQueue(post));
      dispatch(clearReturnClient(0));
    },
    clearReturnClient: (post) => {
      dispatch(clearReturnClient(post));
    },
    returnListCallQueue: (queueid, cbackcount) => {
      dispatch(returnListCallQueue("", queueid, "0", parseInt(cbackcount + 1)));
    },
    ShowVisibleNextAtdIn: (post, temp) => {
      dispatch(ShowVisibleNextAtd(post, temp));
    },
    GetIpCurrent: (ip, audio, difftime, audiomessage, midias) => {
      dispatch(GetIpCurrent(ip, audio, difftime, audiomessage, midias));
    },
    InsertPauseSocketAction: (infousers, pausa, datalogin, idpausa, status) => {
      dispatch(
        InsertPauseSocketAction(infousers, pausa, datalogin, idpausa, status),
      );
    },
    ShowInfoDisplay: (post, ingdesk) => {
      dispatch(ShowInfoDisplay(post, ingdesk));
    },
    RemoveNotifier: (post) => {
      dispatch(RemoveRemoteNotifier(post));
    },
    AlterScreen: (post, previous) => {
      dispatch(AlterScreen(post, previous));
    },
    ChangeAudioInteraction: (post) => {
      dispatch(ChangeAudioInteraction(post));
    },
    ChangeAudioCall: (post) => {
      dispatch(ChangeAudioCall(post));
    },
    ChangeAudioMessage: (post) => {
      dispatch(ChangeAudioMessage(post));
    },
    BlockFutureIn: (post) => {
      dispatch(BlockFuture(post));
    },
    ByeAtendantts: (post) => {
      dispatch(removeAtdUnique());
      dispatch(RemoveAtd(post));
    },
    changeBlockStatus: () => {
      dispatch(changeBlockStatus());
    },
    UpdatePauseFutureRV: (
      infousers,
      status,
      atendimento,
      descpausa,
      idpausa,
    ) => {
      dispatch(
        UpdatePauseFutureRV(infousers, status, atendimento, descpausa, idpausa),
      );
      if (status === "RV") {
        dispatch(BlockFuture(true));
      } else {
        dispatch(BlockFuture(false));
      }
    },
    getDeviceMicrofone: (microfone) => {
      dispatch(getDeviceMicrofone(microfone));
    },
    getDeviceAudio: (audio) => {
      dispatch(getDeviceAudio(audio));
    },
    getDeviceRing: (ring) => {
      dispatch(getDeviceRing(ring));
    },
    onChangePassword: (post, passwordNew) => {
      dispatch(AuthLoginChangePass(post, passwordNew));
    },
    WarningErro: (imsdn, db, sip, mensagem) => {
      dispatch(
        ConnectionsAPI(
          imsdn,
          db,
          sip,
          "Conexão com banco de dados foi perdida :" + mensagem,
        ),
      );
    },
    CloseFaqDragableAndResizer: () => {
      dispatch(setIsOpenFaqDragable(false));
    },
    UpdateUserLoginResponseDispatch: (loginResponse = false) => {
      dispatch(UpdateUserLoginResponse(loginResponse));
    },
    SetIsFuturePauseActive: (status) => {
      dispatch(setIsFuturePauseActive(status));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    InfoUsers: state.informationusers,
    ServiceID: state.servicesidlogin,
    ReasonsBlock: state.reasonsblock,
    ReasonsBlockSup: state.reasonsblocksup,
    ContactId: state.atendimento,
    StatusAgent: state.status,
    QueuePermission: state.queuepermission,
    AtdSimult: state.atdsimult,
    IPCurrent: state.ipcurrent,
    InfoDisplay: state.infodisplay,
    RegisterNotifier: state.registernotifier,
    CurrentScreen: state.currentscreen,
    AutomaticPause: state.automaticpause,
    DeviceList: state.listdevice,
    DeviceListDefault: state.listdevicedefault,
    Connectionsapi: state.connectionsapi,
    InteractionIngdesk: state.interactioningdesk,
    ServiceURL: state.serviceurl,
  };
};

class InfoUser extends React.PureComponent {
  constructor(props) {
    super(props);
    this.meuElemento = null;
    this.state = {
      loading: false,
      buttonActive: false,
      tamanho: 0,
      active: true,
      filter: ["1"],
      reasons: [],
      relogio: [],
      clienteatual: "",
      atdsimult: [],
      registernotifier: [],
      qtdring: 0,
      buttondispEnt: false,
      buttonDispSaida: false,
      buttonDispRing: false,
      descdeviceent: "",
      descdevicesaida: "",
      descdevicering: "",
      arrayusersmidias: [],
      disablePauseFuture: false,
      enableTimeMinPause: false,
      buttonActive2: false,
      changeTypePassword1: true,
      changeTypePassword2: true,
      changeTypePassword3: true,
      valuePasswords: { password: "", passwordNew: "", passwordNewRep: "" },
      verifyError: false,
      popupValue: [],
      popupSelect: false,
      reasonLogoutSelected: [],
    };
  }

  componentDidMount() {
    var blockscreen = this.props.InfoUsers.blockscreen;
    this.setState({
      status: blockscreen ? "Bloqueado" : "Livre",
      PausaId: -1,
      disabled: " disabled",
      buttonPauseDis: false,
      tempPause: -1,
      permitedLogout: false,
      auxstatus: "Livre",
      description: undefined,
      blockfuture: "0",
      // displayfuture: "pausa__futura-btn",
      askpassword: false,
      senhaincorreta: "none",
      justificativabranco: "none",
      buttonNotifier: false,
    });
    this.setDisplayfuture(false);
    this.setState({
      modallivre: "modal-overlay modal__livre",
      modalatendimento: "modal-overlay modal__em-atendimento",
      modalpausado: "modal-overlay modal__pausa-errada",
      modallogout: "modal-overlay modal__logout",
      modaljustificado: "modal-overlay modal__pausa-justificada",
      modalsenha: "modal-overlay modal__ret-pausa",
      modalactions: "modal-overlay modal__actions",
      automaticpause: [],
    });

    setTimeout(() => {
      this.setState({ loading: true });
    }, 5000);
  }
  // componentDidUpdate(prevProps, prevState){
  //   if((prevProps.StatusAgent.status === "Atendimento" || prevProps.StatusAgent.status === "Ligação") && prevProps.StatusAgent.reason!=="CONSULTA" && prevProps.ContactId.length === 0 && activeCall === false && prevProps.InfoUsers.loginresponse === true){
  //       //this.props.AlterStatus('Encerrou','')
  //       activeCall = true;
  //   }

  //   if(activeCall === true){
  //     activeCall = false;
  //   }

  // }

  DisplayBlocks(bind) {
    // e.preventDefault();
    this.setState({ buttonActive: !this.state.buttonActive });
  }

  DisplayBlocks2(bind) {
    // e.preventDefault();
    this.setState({ buttonActive2: !this.state.buttonActive2 });
  }

  toggleClass(e) {
    e.preventDefault();
    this.setState({ active: !this.state.active });
    this.props.expMenu(this.state);
  }

  handleModalPassword = (event, password, infousers, statusagent) => {
    event.preventDefault();
    const senha = this.passwInput.value;
    if (password === md5(senha)) {
      this.setState({
        modalsenha: "modal-overlay modal__ret-pausa",
        askpassword: false,
      });
      const senha = this.passwInput.value;
      const filterpauses = this.parametrosInput.value;
      const parametros = filterpauses.split("|");
      var iddapausa = parametros[2];
      let idpausa = parseInt(iddapausa);

      this.FunctionInsertPause(
        event,
        infousers,
        parametros[0],
        parametros[1],
        idpausa,
        parametros[3],
        parametros[4],
        parametros[5],
        parametros[6],
        statusagent,
        parametros[9],
      );
      this.parametrosInput.value = "";
      this.passwInput.value = "";
      this.setState({ senhaincorreta: "none" });
    }
    this.setState({ senhaincorreta: "block" });
  };

  InsertPause = async (
    event,
    infousers,
    datalogin,
    pausa,
    idpausa,
    status,
    logout,
    description,
    allowuse,
    statusagent,
    time,
    timemin,
    ContactId,
  ) => {
    if (!!event) {
      event.preventDefault();
    }

    if (!this.state.enableTimeMinPause) {
      if (
        this.state.status === "Atendimento" ||
        this.state.status === "Ligação" ||
        this.state.status === "Discando" ||
        this.state.status === "Aftercallwork" ||
        this.state.status === "Chamando"
      ) {
        if (pausa === "Livre") {
          console.log("Você está em atendimentos");
        } else {
          if (logout === true) {
            this.BlockFuture(
              event,
              infousers,
              pausa,
              datalogin,
              idpausa,
              status,
              logout,
              description,
              allowuse,
              time,
              timemin,
            );
            this.props.UpdatePauseFutureRV(
              infousers,
              "RV",
              ContactId,
              pausa,
              idpausa,
            );
            // this.DisplayModal(event, 'modalatendimento')
          } else {
            if (infousers.max_agents_on_pause > 0) {
              const response = await getFreeAgentsById(
                infousers.idgroup,
                infousers.id,
                infousers.checkpausa,
              );
              // const response = false; // aqui vem a api que verifica a quantidade de free agents

              if (
                response.status === 200 &&
                response.data.free_pause_agents === false
              ) {
                toast.custom(
                  <div className="container__pause-automatic_remove">
                    <div className="container__pause-automatic__icon">
                      <DangerIcon />
                    </div>
                    <div className="container__pause-automatic__separator">
                      <div className="container__pause-automatic__box">
                        <strong>Pausa indisponível no momento.</strong>
                        <div
                          className="container__pause-automatic__box-icon"
                          onClick={() => closeToast()}
                        >
                          <IconClose />
                        </div>
                      </div>
                      <span>
                        Não há operadores livres suficientes no seu grupo para
                        permitir sua saída agora.
                      </span>
                    </div>
                  </div>,
                  {
                    id: 1,
                    position: "top-center",
                  },
                );

                document.querySelector(".header-main").click();
                this.setState({ buttonActive: false });
                return;
              } else if (response.status !== 200) {
                toast.custom(
                  <div className="container__pause-automatic_remove">
                    <div className="container__pause-automatic__icon">
                      <DangerIcon />
                    </div>
                    <div className="container__pause-automatic__separator">
                      <div className="container__pause-automatic__box">
                        <strong>Não foi possível aplicar a pausa.</strong>
                        <div
                          className="container__pause-automatic__box-icon"
                          onClick={() => closeToast()}
                        >
                          <IconClose />
                        </div>
                      </div>
                      <span>
                        Entre em contato com o suporte para verificar o erro no
                        seu grupo ao aplicar a pausa.
                      </span>
                    </div>
                  </div>,
                  {
                    id: 1,
                    position: "top-center",
                  },
                );

                document.querySelector(".header-main").click();
                this.setState({ buttonActive: false });
                return;
              }
            }

            this.BlockFuture(
              event,
              infousers,
              pausa,
              datalogin,
              idpausa,
              status,
              logout,
              description,
              allowuse,
              time,
              timemin,
              ContactId,
            );
            //this.props.UpdatePauseFutureRV(infousers,'RV',ContactId,pausa)
          }
        }
      } else {
        if (this.state.status != pausa && this.state.askpassword === false) {
          if (infousers.max_agents_on_pause > 0 && !logout) {
            const response = await getFreeAgentsById(
              infousers.idgroup,
              infousers.id,
              infousers.checkpausa,
            );

            if (
              response.status === 200 &&
              response.data.free_pause_agents === false
            ) {
              toast.custom(
                <div className="container__pause-automatic_remove">
                  <div className="container__pause-automatic__icon">
                    <DangerIcon />
                  </div>
                  <div className="container__pause-automatic__separator">
                    <div className="container__pause-automatic__box">
                      <strong>Pausa indisponível no momento.</strong>
                      <div
                        className="container__pause-automatic__box-icon"
                        onClick={() => closeToast()}
                      >
                        <IconClose />
                      </div>
                    </div>
                    <span>
                      Não há operadores livres suficientes no seu grupo para
                      permitir sua saída agora.
                    </span>
                  </div>
                </div>,
                {
                  id: 1,
                  position: "top-center",
                },
              );

              document.querySelector(".header-main").click();
              this.setState({ buttonActive: false });
              return;
            } else if (response.status !== 200) {
              toast.custom(
                <div className="container__pause-automatic_remove">
                  <div className="container__pause-automatic__icon">
                    <DangerIcon />
                  </div>
                  <div className="container__pause-automatic__separator">
                    <div className="container__pause-automatic__box">
                      <strong>Não foi possível aplicar a pausa.</strong>
                      <div
                        className="container__pause-automatic__box-icon"
                        onClick={() => closeToast()}
                      >
                        <IconClose />
                      </div>
                    </div>
                    <span>
                      Entre em contato com o suporte para verificar o erro no
                      seu grupo ao aplicar a pausa.
                    </span>
                  </div>
                </div>,
                {
                  id: 1,
                  position: "top-center",
                },
              );

              document.querySelector(".header-main").click();
              this.setState({ buttonActive: false });
              return;
            }
          }

          this.FunctionInsertPause(
            event,
            infousers,
            datalogin,
            pausa,
            idpausa,
            status,
            logout,
            description,
            allowuse,
            statusagent,
            time,
            timemin,
          );
        } else if (
          this.state.status != pausa &&
          this.state.askpassword === true
        ) {
          this.parametrosInput.value =
            datalogin +
            "|" +
            pausa +
            "|" +
            idpausa +
            "|" +
            status +
            "|" +
            logout +
            "|" +
            description +
            "|" +
            allowuse +
            "|" +
            time +
            "|" +
            timemin;
          this.setState({
            modalsenha: "modal-overlay modal__ret-pausa active",
          });
        }
        if (timemin !== 0 && idpausa !== "-1") {
          this.setState({ enableTimeMinPause: true });
          setTimeout(() => {
            this.setState({ enableTimeMinPause: false });
          }, [timemin * 1000]);
        }
      }
      this.setState({ buttonActive: false });
    } else {
      this.setState({ buttonActive: false });
      toast.custom(
        <div className="container__pause-automatic_remove">
          <div className="container__pause-automatic__icon">
            <DangerIcon />
          </div>
          <div className="container__pause-automatic__separator">
            <div className="container__pause-automatic__box">
              <strong>Você não tem permissão para retirar esta pausa.</strong>
              <div
                className="container__pause-automatic__box-icon"
                onClick={() => closeToast()}
              >
                <IconClose />
              </div>
            </div>
            <span>
              Aguarde atingir o tempo limite para poder remover a pausa.
            </span>
          </div>
        </div>,
        {
          id: 1,
          position: "top-center",
        },
      );
    }

    document.querySelector(".header-main").click();
    if (
      logout === "true" ||
      (logout === true &&
        this.state.modallogout !== "modal-overlay modal__logout active")
    ) {
      this.DisplayModal(event, "modallogout");
    }
    // this.DisplayBlocks.bind(this);
  };

  BlockFuture(
    event,
    infousers,
    pausa,
    datalogin,
    idpausa,
    status,
    logout,
    description,
    allowuse,
    time,
    timemin,
    ContactId,
  ) {
    if (description === "false" || description === false) {
      if (this.state.status != pausa && this.state.askpassword === false) {
        this.parametrosBlockFuture.value = "";
        this.parametrosBlockFuture.value =
          datalogin +
          "|" +
          pausa +
          "|" +
          idpausa +
          "|" +
          status +
          "|" +
          logout +
          "|" +
          description +
          "|" +
          allowuse +
          "|undefined|" +
          time +
          "|" +
          timemin;
        // this.setState({ displayfuture: "pausa__futura-btn active" });
        this.setDisplayfuture(true);
        this.props.UpdatePauseFutureRV(
          infousers,
          "RV",
          ContactId,
          pausa,
          idpausa,
        );
        this.setState({
          reasonname: pausa,
        });
      }
    } else if (description === true) {
      this.setState({
        pauseJust: pausa,
        reasonname: pausa,
        reasonid: idpausa,
        description: description,
        allowuse: allowuse,
        logout: logout,
        timemaxpause: time,
      });
      this.DisplayModal(event, "modaljustificado");
      //this.setState({displayfuture: 'pausa__futura-btn active'});
    }
  }

  removePauseActive() {
    // this.setState({ disablePauseFuture: true });
    this.setState({ disablePauseFuture: false });
    this.props.handleNextPauseAutomatice();
  }

  SetBlockFuture(infousers, datalogin, AtdSimult, statusagent) {
    var event = [];
    const filterfutures = this.parametrosBlockFuture.value;
    const parametros = filterfutures.split("|");
    let iddapausa = parametros[2];
    let idpausa = parseInt(iddapausa);

    if (filterfutures != "") {
      if (parametros[7] !== undefined && parametros[7] !== "undefined") {
        this.InsertReasonJustified(
          event,
          infousers,
          parametros[0],
          parametros[1],
          parametros[3],
          idpausa,
          parametros[4],
          parametros[5],
          parametros[6],
          parametros[7],
          parametros[8],
          parametros[5] === "true"
            ? parseInt(parametros[9])
            : parseInt(parametros[7]),
          parametros[9],
        );
        this.parametrosBlockFuture.value = "";
        // this.setState({ displayfuture: "pausa__futura-btn" });
        this.setDisplayfuture(false);
      } else {
        if (parseInt(parametros[9]) !== 0) {
          this.setState({ enableTimeMinPause: true });
          setTimeout(() => {
            this.setState({ enableTimeMinPause: false });
          }, [parseInt(parametros[9]) * 1000]);
        }

        let tmpmaxpause =
          parseInt(parametros[9]) > parseInt(parametros[8])
            ? parseInt(parametros[9])
            : parseInt(parametros[8]);
        let tmpminpause =
          parseInt(parametros[9]) > parseInt(parametros[8])
            ? parseInt(parametros[8])
            : parseInt(parametros[9]);

        this.FunctionInsertPause(
          event,
          infousers,
          parametros[0],
          parametros[1],
          idpausa,
          parametros[3],
          parametros[4],
          parametros[5],
          parametros[6],
          statusagent,
          tmpmaxpause,
          tmpminpause,
        );
        this.parametrosBlockFuture.value = "";
        // this.setState({ displayfuture: "pausa__futura-btn" });
        this.setDisplayfuture(false);
      }
      this.props.BlockFutureIn(false);
    } else {
      if (AtdSimult.length != 0) {
        // if(AtdSimult.length != 0){
        //this.FunctionInsertPause(event, infousers, datalogin,'Atendimento',-1, 'RV','false','false','false',statusagent)
      } else {
        if (statusagent.afterStatus === "Pausado") {
          this.FunctionInsertPause(
            event,
            infousers,
            datalogin,
            statusagent.afterReason,
            statusagent.afterIdReason,
            infousers.status,
            statusagent.afterIsReasonLogout,
            false,
            false,
            infousers.status,
            84600,
            true,
          );
        } else {
          this.FunctionInsertPause(
            event,
            infousers,
            datalogin,
            "Livre",
            -1,
            "LV",
            "false",
            "false",
            "false",
            statusagent,
          );
        }
      }
    }
  }

  setDisplayfuture(isActive) {
    if (isActive) {
      this.setState({ displayfuture: "pausa__futura-btn active" });
      this.props.SetIsFuturePauseActive(true);
    } else {
      this.setState({ displayfuture: "pausa__futura-btn" });
      this.props.SetIsFuturePauseActive(false);
    }
  }

  BreakBlockFuture(event, infousers, ContactId) {
    if (this.state.disablePauseFuture === false) {
      this.parametrosBlockFuture.value = "";
      // this.setState({ displayfuture: "pausa__futura-btn" });
      this.setDisplayfuture(false);
      this.props.UpdatePauseFutureRV(infousers, "AT", ContactId, null, null);
      this.props.changeBlockStatus();
      this.setState({ reasonname: "" });
    } else {
      toast.custom(
        <div className="container__pause-automatic_remove">
          <div className="container__pause-automatic__icon">
            <DangerIcon />
          </div>
          <div className="container__pause-automatic__separator">
            <div className="container__pause-automatic__box">
              <strong>
                Você não tem permissão para retirar esta pausa futura.
              </strong>
              <div
                className="container__pause-automatic__box-icon"
                onClick={() => closeToast()}
              >
                <IconClose />
              </div>
            </div>
            <span>
              Após o encerramento do seu atendimento, a sua pausa automática
              será aplicada.
            </span>
          </div>
        </div>,
        {
          id: 1,
          position: "top-center",
        },
      );
    }
  }

  UpdateToServiceAtd(serviceatd) {
    this.props.UpdateServiceAtd(serviceatd);
  }

  FunctionInsertPause(
    event,
    infousers,
    datalogin,
    pausa,
    idpausa,
    status,
    logout,
    description,
    allowuse,
    statusagent,
    time,
    isblockfuture,
  ) {
    //event.preventDefault();
    if (description === false || description === "false") {
      if (pausa === "Livre") {
        this.SetStateBlock(event, pausa, idpausa, time, logout);
        if (statusagent.status == "Pausado") {
          this.props.exUpdateRgBlock(infousers, idpausa);
        }
        this.setState({ disablePauseFuture: false });
        //this.ReleaseLogout(event, pausa)
        this.props.IdleSocketIn(
          infousers,
          pausa,
          datalogin,
          idpausa,
          status,
          statusagent,
        );
      } else {
        if (this.state.tempPause === -1) {
          this.props.exInsertRgBlock(infousers, idpausa);
        } else {
          this.props.exUpdateInRgBlock(
            infousers,
            idpausa,
            undefined,
            this.state.PausaId,
          );
        }
        this.props.exSTPausaDB(infousers, status);
        this.ReleaseLogout(event, logout);
        this.SetStateBlock(event, pausa, idpausa, time, logout);
        this.SetToSocket(event, infousers, pausa, datalogin, idpausa, status);
      }
      this.ClearTime(0, 0, 0, idpausa);
      if (logout === true && !isblockfuture) {
        this.DisplayModal(event, "modallogout");
      }
    } else {
      this.setState({
        pauseJust: pausa,
        reasonname: pausa,
        reasonid: idpausa,
        description: description,
        allowuse: allowuse,
        reasonlogout: logout,
        timemaxpause: time,
      });
      this.DisplayModal(event, "modaljustificado");
    }
  }

  SetToSocket(event, infousers, pausa, datalogin, idpausa, status) {
    this.props.InsertPauseSocketAction(
      infousers,
      pausa,
      datalogin,
      idpausa,
      status,
    );
    //const socket = InsertPauseSocket(infousers,pausa,datalogin,idpausa,status)
  }

  ReleaseLogout(event, logout, reason, idpausa) {
    if (logout === true || logout === "true") {
      this.setState({ permitedLogout: true });
      this.props.AlterStatus("Logout", "Sair");
    } else if (logout === "Livre") {
      this.setState({ permitedLogout: false });
    } else {
      this.setState({ permitedLogout: false });
      // this.props.AlterStatus('Pausado',reason,idpausa);
    }
  }

  ReasonJustified(
    event,
    infousers,
    datalogin,
    pausa,
    status,
    idpausa,
    logout,
    description,
    auxPause,
    allowuse,
    time,
    timemin,
    ContactId,
  ) {
    if (ContactId.idatendimento !== undefined && ContactId.idatendimento > 0) {
      this.props.UpdatePauseFutureRV(
        infousers,
        "RV",
        ContactId,
        pausa,
        idpausa,
      );
      // this.setState({ displayfuture: "pausa__futura-btn active" });
      this.setDisplayfuture(true);
    }

    event.preventDefault();
    const value = this.textInput.value;
    if (this.state.status != "Atendimento" && this.state.status != "Ligação") {
      if (value != "") {
        this.InsertReasonJustified(
          event,
          infousers,
          datalogin,
          pausa,
          status,
          idpausa,
          logout,
          description,
          auxPause,
          allowuse,
          value,
          time,
          timemin,
        );
      } else {
        this.setState({ tempPause: auxPause, justificativabranco: "block" });
      }
    } else {
      if (value != "") {
        this.parametrosBlockFuture.value = "";
        this.parametrosBlockFuture.value =
          datalogin +
          "|" +
          pausa +
          "|" +
          idpausa +
          "|" +
          status +
          "|" +
          logout +
          "|" +
          description +
          "|" +
          allowuse +
          "|" +
          value +
          "|" +
          time +
          "|" +
          timemin;
        this.CloseModal("modaljustificado");
      } else {
        this.setState({ tempPause: auxPause, justificativabranco: "block" });
      }
    }
  }

  InsertReasonJustified(
    event,
    infousers,
    datalogin,
    pausa,
    status,
    idpausa,
    logout,
    description,
    auxPause,
    allowuse,
    value,
    time,
    timemin,
  ) {
    this.textInput.value = "";
    //const socket = InsertPauseSocket(infousers,pausa,datalogin,idpausa,status)
    this.props.InsertPauseSocketAction(
      infousers,
      pausa,
      datalogin,
      idpausa,
      status,
    );
    this.props.exSTPausaDB(infousers, status);
    if (this.state.tempPause === -1) {
      this.props.exInsertRgBlock(infousers, idpausa, value);
      this.SetStateBlock(event, pausa, idpausa, time, logout);
    } else {
      this.props.exUpdateInRgBlock(infousers, idpausa, value);
      this.SetStateBlock(event, pausa, idpausa, time, logout);
    }
    if (allowuse === false && description === "true") {
      this.setState({ askpassword: true });
    } else {
      this.setState({ askpassword: false });
    }
    this.ReleaseLogout(event, logout, idpausa);
    this.ClearTime(0, 0, 0, idpausa);
  }

  SetStateBlock(event, pausa, idpausa, time, logout) {
    if (pausa === "Livre") {
      this.setState({
        status: pausa,
        disabled: " disabled",
        soundinteration: false,
        buttonPauseDis: false,
        PausaId: -1,
        tempPause: idpausa,
        permitedLogout: "false",
      });
    } else {
      this.setState({
        status: pausa,
        disabled: "",
        buttonPauseDis: true,
        PausaId: idpausa,
        tempPause: idpausa,
        timemaxpause: time,
      });
      this.CloseModal("modaljustificado");
      this.props.AlterStatus("Pausado", pausa, idpausa, logout);
    }
    this.setState({ senhaincorreta: "none", justificativabranco: "none" });
  }

  FuncLogoutInV2(event, infousers, servicesid, agent, contactId) {
    event.preventDefault();
    const allReasons = this.state.reasons;
    const hasAllReasons =
      !!allReasons && Array.isArray(allReasons) && allReasons.length > 0;
    const logoutReasons = hasAllReasons
      ? allReasons.filter((reason) => reason.logout === true)
      : [];
    const hasLogoutReasons =
      !!logoutReasons &&
      Array.isArray(logoutReasons) &&
      logoutReasons.length > 0;
    if (hasLogoutReasons) {
      const reason = logoutReasons[0];
      this.InsertPause(
        event,
        infousers,
        datalogin,
        reason.name,
        reason.id,
        "BQ",
        reason.logout,
        reason.isdescription,
        reason.allow_use,
        agent,
        reason.durationmaxblock,
        reason.durationminblock,
        contactId,
      );
      this.setState({
        reasonLogoutSelected: [{ ...reason, label: reason.name }],
      });
    }
  }

  FuncLogoutIn(event, infousers, servicesid, agent) {
    event.preventDefault();
    if (this.state.permitedLogout === true) {
      this.DisplayModal(event, "modallogout");
    } else {
      switch (agent.status) {
        case "Livre":
          this.DisplayModal(event, "modallivre");
          break;
        case "Pausado":
          this.DisplayModal(event, "modalpausado");
          break;
        case "Atendimento":
          this.DisplayModal(event, "modalatendimento");
          break;
      }
    }
  }

  LogoutOut(event, infousers, servicesid, agent, serviceurl) {
    previusMessagesService.clearAllLoadedCdrs();
    reqServiceSingleton.resetAll();
    autoAsnwerCallbackServiceSingleton.resetList();
    voiceService.clearIdsAtendimentoToRejectIdsList();
    reconnectionHandler.resetReconnectionHandler();
    this.props.UpdateUserLoginResponseDispatch(false);
    noReadHandler.clearIsLoaded();
    this.props.SetIsFuturePauseActive(false);
    event.preventDefault();
    this.props.CloseFaqDragableAndResizer();
    const { Connectionsapi } = this.props;
    let serviceid = servicesid.servicesid;
    let url_iframe = "";

    if (serviceurl.length !== 0) {
      let ArrayServiceURL = "";
      if (infousers.nameauth === "IngDesk") {
        ArrayServiceURL = serviceurl.filter(
          (url) => url.typeofcrm === "IngDesk",
        );
        if (ArrayServiceURL.length !== 0) {
          url_iframe = ArrayServiceURL[0].param;
        }
      }
    }

    // if(connection_platform.nc2_integration === true){
    //   var response = nc2Service.nc2Logoff(infousers.ramal)
    //   if(response)
    //     document.getElementById("logoutclicado").click();
    // }
    if (url_iframe !== "")
      Connectionsapi.iframe_ref.current.contentWindow.postMessage(
        { origin: "ingweb", id: "logout" },
        url_iframe,
      );

    if (serviceid !== undefined) {
      let idserviceslogin = serviceid.map((e) => e.id).join();

      if (this.state.displayfuture === "pausa__futura-btn active") {
        const filterpauses = this.parametrosBlockFuture.value;
        const parametros = filterpauses.split("|");
        this.props.exInsertRgBlock(infousers, parametros[2]);
      } else {
        this.props.exUpdateInRgBlock(
          infousers,
          this.state.idpausa,
          null,
          null,
          idserviceslogin,
          agent,
          true,
        );
      }
      this.props.exLogoutIn(infousers, idserviceslogin, agent);
      localStorage.setItem("info_login", "useroff");
      localStorage.setItem("info_iduser", "useroff");
      webphone_api.delsettings(2);
      if (connection_platform.azure_auth === true) {
        b2cauth.signOut();
        window.open(
          `${connection_platform.type_connect}://${window.location.hostname}:${connection_platform.port_node}`,
          "_self",
        );
      }

      if (connection_platform.azure_auth === false) {
        if (
          connection_platform.nc2_integration === true &&
          connection_platform.nc2_users.indexOf(infousers.ramal) !== -1
        ) {
          var response = nc2Service.nc2Logoff(infousers.ramal);
          setTimeout(function () {
            document.getElementById("logoutclicado").click();
          }, 3000);
          // var response = nc2Service.nc2Logoff(infousers.ramal)
          // if(response){
          //   document.getElementById("logoutclicado").click();
          // }else{
          //   setTimeout(function() {
          //       document.getElementById("logoutclicado").click();
          //     }, 6000);
          // }
        } else {
          setTimeout(function () {
            document.getElementById("logoutclicado").click();
          }, 3000);
        }
      }
      // if(connection_platform.nc2_integration === true && connection_platform.nc2_users.indexOf(infousers.ramal) !== -1){
      //   var response = nc2Service.nc2Logoff(infousers.ramal)
      //   if(response)
      //     document.getElementById("logoutclicado").click();
      // }
    }
  }

  LogoutSup() {
    if (connection_platform.azure_auth === true) {
      b2cauth.signOut();
      window.open(
        `${connection_platform.type_connect}://${window.location.hostname}:${connection_platform.port_node}`,
        "_self",
      );
    }

    if (connection_platform.azure_auth === false) {
      setTimeout(function () {
        document.getElementById("logoutclicado").click();
      }, 3000);
    }
  }

  FinishAtendant(status, contactid, IPCurrent) {
    var recuperation = contactid.recuperation;
    var recuperationtime = contactid.recuperationtime;
    this.setState({ auxstatus: status });

    if (status === "Atendimento" && recuperation === "1") {
      var hours = Math.floor(recuperationtime / 3600);
      var minutes = Math.floor((recuperationtime % 3600) / 60);
      var seconds = recuperationtime % 60;
      this.ClearTime(hours, minutes, seconds);
    } else {
      this.ClearTime(0, 0, 0);
    }
  }

  DisplayModal(event, modal) {
    switch (modal) {
      case "modallivre":
        this.setState({ modallivre: "modal-overlay modal__livre active" });
        break;
      case "modalatendimento":
        this.setState({
          modalatendimento: "modal-overlay modal__atendimento active",
        });
        break;
      case "modalpausado":
        this.setState({
          modalpausado: "modal-overlay modal__pausa-errada active",
        });
        break;
      case "modallogout":
        this.setState({ modallogout: "modal-overlay modal__logout active" });
        break;
      case "modaljustificado":
        this.setState({
          modaljustificado: "modal-overlay modal__pausa-justificada active",
        });
        break;
      case "modalsenha":
        this.setState({ modalsenha: "modal-overlay modal__ret-pausa active" });
        this.parametrosInput.value = "";
        this.setState({ senhaincorreta: "none" });
        break;
      case "modalactions":
        this.setState({ modalactions: "modal-overlay modal__actions active" });
        document.querySelector(".header-main").click();
        break;
      default:
        break;
    }
  }

  CloseModal(modal) {
    switch (modal) {
      case "modallivre":
        this.setState({ modallivre: "modal-overlay modal__livre" });
        break;
      case "modalatendimento":
        this.setState({ modalatendimento: "modal-overlay modal__atendimento" });
        break;
      case "modalpausado":
        this.setState({ modalpausado: "modal-overlay modal__pausa-errada" });
        break;
      case "modallogout":
        this.setState({ modallogout: "modal-overlay modal__logout" });
        break;
      case "modaljustificado":
        this.setState({
          modaljustificado: "modal-overlay modal__pausa-justificada",
          justificativabranco: "none",
        });
        break;
      case "modalsenha":
        this.setState({ modalsenha: "modal-overlay modal__ret-pausa" });
        document.getElementById("armazenapausa").value = "";
        break;
      case "modalactions":
        this.setState({ modalactions: "modal-overlay modal__actions" });
        this.handleClearInfos();
        break;
      default:
        break;
    }
  }

  ClearTime(hh, mm, ss, idpausa) {
    this.setState({ cleartime: idpausa });
    this.hh = hh;
    this.mm = mm;
    this.ss = ss;
  }

  VerifiedReturn(CallBack, InfoUsers, ContactId, QueuePermission, display) {
    var queuepermission = QueuePermission.queuepermission;
    var auxtemp = false;
    var customerwait = true;
    var caller = ContactId.telefone;

    if (CallBack.length != 0) {
      for (let i = 0; i < CallBack.length; i++) {
        if (caller === CallBack[i].caller) {
          var recvcount = CallBack[i].recvcount;
          var cbackcount = CallBack[i].callback_count;
          var cdridnew = ContactId.idatendimento;
          var cdrid = CallBack[i].cdrid;
          var queueid = CallBack[i].queueid;
          var caller = CallBack[i].caller;
          var called = CallBack[i].called;
          var media = CallBack[i].media;
          var username = InfoUsers.username;
          var respatendente = CallBack[i].respatendente;
          var respclient = CallBack[i].respclient;
          var srvin = CallBack[i].srvin;
          var iduser = InfoUsers.id;
        }
      }

      for (let i = 0; i < queuepermission.length; i++) {
        if (queuepermission[i].serviceinid === parseInt(srvin)) {
          var customerwait = queuepermission[i].customer_wait;
        }
      }

      if (respclient === 1) auxtemp = true;

      if (respatendente === 1 && customerwait === false) auxtemp = true;

      if (auxtemp === true) {
        const socket = SendSocketClearReturn(
          cbackcount,
          recvcount,
          cdrid,
          cdridnew,
          queueid,
          iduser,
          username,
          "RM",
          media,
          caller,
          called,
          srvin,
        );
        this.props.RemoveCallQueueReturn(queueid);
      } else {
        const socket = SendSocketClearReturn(
          cbackcount,
          recvcount,
          cdrid,
          cdridnew,
          queueid,
          iduser,
          username,
          "NANS",
          media,
          caller,
          called,
          srvin,
        );
        this.props.clearReturnClient(0);
        this.props.returnListCallQueue(queueid, cbackcount);
      }
    }
    this.props.ShowVisibleNextAtdIn(display, display);
  }

  InputOutputAudio(event, reduxipcurrent) {
    let audio = !reduxipcurrent.audio;
    this.props.ChangeAudioInteraction(audio);
    saveToStorage(audio);
  }

  InputOutputAudioCall(event, reduxipcurrent) {
    let audio = !reduxipcurrent.audiocall;
    this.props.ChangeAudioCall(audio);
    saveToStorageCall(audio);
  }

  ChangeAudioMessage(event, reduxipcurrent) {
    this.props.ChangeAudioMessage(!reduxipcurrent.audiomessage);
    saveToStorageMsg(!reduxipcurrent.audiomessage);
  }

  ChangeEchoCanceler(event) {
    var elemento = document.getElementById("echo_canceler").checked;
    if (elemento === true) {
      webphone_api.setparameter("aec", 2);
    } else {
      webphone_api.setparameter("aec", 0);
    }
  }

  ShowInfoDisplay(
    e,
    display,
    idnotifier,
    screenprevious,
    ingdesk,
    received_ingdesk,
  ) {
    const { Connectionsapi, ServiceURL, InfoUsers } = this.props;
    let url_iframe = "";

    if (ServiceURL.length !== 0) {
      let ArrayServiceURL = "";
      if (InfoUsers.nameauth === "IngDesk") {
        ArrayServiceURL = ServiceURL.filter(
          (url) => url.typeofcrm === "IngDesk",
        );
        if (ArrayServiceURL.length !== 0) {
          url_iframe = ArrayServiceURL[0].param;
        }
      }
    }

    if (display === "mensagemchat") {
      this.props.ShowInfoDisplay("Atendentes");
      this.props.RemoveNotifier(idnotifier);
    } else if (display === "mensagemgrupo") {
      this.props.RemoveNotifier(idnotifier);
      MicroModal.show("modal__mensagem-equipe");
      this.props.AlterScreen("ChatGrupo", screenprevious);
    } else if (display === "mensagememail") {
      this.props.RemoveNotifier(idnotifier);
      this.props.ShowInfoDisplay("Clientes");
    } else if (display === "vertodas") {
      MicroModal.show("modal__notificacoes");
    } else if (display === "mensagemingdesk") {
      if (received_ingdesk.display === "reminder") {
        Connectionsapi.iframe_ref.current.contentWindow.postMessage(
          [received_ingdesk],
          url_iframe,
        );
      }

      this.props.RemoveNotifier(idnotifier);

      if (received_ingdesk.display === "caseAlert") {
        this.RemoveNotifier(e, idnotifier, received_ingdesk);
        this.props.ShowInfoDisplay("Casos", "casos/" + received_ingdesk.idCase);
      } else {
        this.props.ShowInfoDisplay(
          "IngDesk",
          "tarefas/" + received_ingdesk.idTask,
        );
      }
    }

    document.getElementById("simulation_click").click();
    this.setState({ newnotifier: false });
  }

  RemoveNotifier(e, idnotifier, received_ingdesk) {
    const { Connectionsapi, ServiceURL, InfoUsers } = this.props;
    let url_iframe = "";

    if (ServiceURL.length !== 0) {
      let ArrayServiceURL = "";
      if (InfoUsers.nameauth === "IngDesk") {
        ArrayServiceURL = ServiceURL.filter(
          (url) => url.typeofcrm === "IngDesk",
        );
        if (ArrayServiceURL.length !== 0) {
          url_iframe = ArrayServiceURL[0].param;
        }
      }
    }

    if (received_ingdesk) {
      if (received_ingdesk.display === "reminder") {
        Connectionsapi.iframe_ref.current.contentWindow.postMessage(
          {
            id: "remindersConcluded",
            origin: "ingweb",
            payload: [received_ingdesk],
          },
          url_iframe,
        );
      } else if (received_ingdesk.display === "caseAlert") {
        console.debug("(INGWEB) RemoveCaseAlert - todo: ", received_ingdesk);
        Connectionsapi.iframe_ref.current.contentWindow.postMessage(
          {
            id: "caseAlertConcluded",
            origin: "ingweb",
            payload: [received_ingdesk],
          },
          url_iframe,
        );
      }
    }

    this.props.RemoveNotifier(idnotifier);
  }

  RemoveNotifierMail(e, idnotifier) {
    this.props.RemoveNotifier(idnotifier);
  }

  ButtonOkPopoverNotifier(e) {
    document.getElementById("simulation_click").click();
  }

  FilterDispEnt(e) {
    // e.preventDefault();
    this.setState({ buttondispEnt: !this.state.buttondispEnt });
  }
  FilterDispSaida(e) {
    // e.preventDefault();
    this.setState({ buttonDispSaida: !this.state.buttonDispSaida });
  }
  FilterDispRing(e) {
    // e.preventDefault();
    this.setState({ buttondispRing: !this.state.buttondispRing });
  }
  FilterDispPopUp(e) {
    // e.preventDefault();
    this.setState({ popupSelect: !this.state.popupSelect });
  }

  applyFill(elemento) {
    var slider = document.getElementById(elemento);

    var percentage =
      (100 * (slider.value - slider.min)) / (slider.max - slider.min);
    var bg = `linear-gradient(90deg, #005daa ${percentage}%, #d7dcdf ${
      percentage + 0.1
    }%)`;
    this.setState({ microfone: percentage });

    slider.style.background = bg;

    if (slider.value > 100) {
      var bg = `linear-gradient(90deg, #ea1c18 ${percentage}%, #d7dcdf ${
        percentage + 0.1
      }%)`;
      slider.style.background = bg;
    }
  }

  renderPopoverNotifier = (
    e,
    IPCurrent,
    RegisterNotifier,
    screenprevious,
    DeviceList,
    DeviceListDefault,
  ) => (
    <div className="context-menu__notifications" id="notificacoes">
      <ul className="context-menu__list">
        <li className={" acoes__item acoes__item__notification active"}>
          <div className="acoes__item__notification__header">
            <div
              className="acoes__item__notification__title"
              // onClick={(e) =>
              //   this.setState({
              //     buttonshowlessnotifier: !this.state.buttonshowlessnotifier,
              //   })
              // }
            >
              <div className="acoes__item__text acoes__item__text--bold">
                Notificações
              </div>
              {/* <i className="material-icons">keyboard_arrow_down</i> */}
            </div>
            <div className="item-notification__btn">
              <button
                className="btn--text"
                onClick={(event) => this.ShowInfoDisplay(event, "vertodas")}
              >
                <AllNotifIcon />
              </button>
            </div>
          </div>
          <div className="acoes__item__notification__body">
            {/* <!-- item notification --> */}
            {/* <div className="item-notification item-notification--system">
                  <div className="item-notification__content">
                    <i className="material-icons">warning</i>
                    <p className="item-notification__content__title">
                      <span className="item-notification__content__title item-notification__content__title__name">Lorem</span>
                      borem store stilled mareds
                      <span className="item-notification__content__title item-notification__content__title__time">(38min)</span>
                      <button className="btn--text">Dispensar</button>
                    </p>
                  </div>    
                        
                </div>  */}
            {/* <!-- end item -->
                <!-- item notification --> */}
            {/* <div className="item-notification item-notification--chat">
                  <div className="item-notification__content">
                    <i className="material-icons">announcement</i>
                    <p className="item-notification__content__title">
                      <span className="item-notification__content__title item-notification__content__title__name">Lorem</span>
                      borem lorem as lorem
                      <span className="item-notification__content__title item-notification__content__title__time">(38min)</span>
                      <button className="btn--text">Dispensar</button>
                    </p>
                  </div>    
                        
                </div>  */}
            {/* <!-- end item -->
        
                <!-- item notification --> */}
            {RegisterNotifier.filter(
              (register) => register.display !== "mensagememail",
            ).length > 0 ? (
              RegisterNotifier.filter(
                (register) => register.display !== "mensagememail",
              )
                .sort((a, b) => b.idnotifier - a.idnotifier)
                .map((notifier) =>
                  (() => {
                    const now = Moment();
                    const before = Moment(notifier.data);
                    const data = Moment(now - before).format("m[min]");

                    return (
                      <div
                        className="item-notification item-notification--chat-group"
                        key={keycount++}
                      >
                        {(() => {
                          if (notifier.display === "mensagememail-disabled") {
                            return (
                              <div className="item-notification__content">
                                <div
                                  className="item-notification__content-header"
                                  onClick={(event) =>
                                    this.ShowInfoDisplay(
                                      event,
                                      "mensagememail",
                                      notifier.remote,
                                    )
                                  }
                                >
                                  <i className="material-icons">mail</i>
                                  <p
                                    className="item-notification__content__title"
                                    onClick={(event) =>
                                      this.ShowInfoDisplay(
                                        event,
                                        "mensagememail",
                                        notifier.remote,
                                      )
                                    }
                                  >
                                    <span className="item-notification__content__title__name">
                                      {notifier.author}
                                    </span>
                                    <span className="item-notification__content__title__time">
                                      {data}
                                    </span>
                                  </p>
                                </div>
                                <div
                                  className="item-notification__content-description__mail"
                                  onClick={(event) =>
                                    this.ShowInfoDisplay(
                                      event,
                                      "mensagememail",
                                      notifier.remote,
                                    )
                                  }
                                >
                                  <span>
                                    {ReactHtmlParser(notifier.description)}
                                  </span>
                                  <button
                                    onClick={(event) => {
                                      this.RemoveNotifierMail(
                                        event,
                                        notifier.idnotifier,
                                      );
                                    }}
                                    className="btn--text"
                                  >
                                    Dispensar
                                  </button>
                                </div>
                              </div>
                            );
                          } else if (notifier.display !== "mensagememail") {
                            return (
                              <div className="item-notification__content">
                                <div className="item-notification__content-header">
                                  {(() => {
                                    if (notifier.display === "mensagemchat") {
                                      return (
                                        <i className="material-icons">
                                          question_answer
                                        </i>
                                      );
                                    } else if (
                                      notifier.display === "mensagemgrupo"
                                    ) {
                                      return (
                                        <i className="material-icons">
                                          announcement
                                        </i>
                                      );
                                    } else if (
                                      notifier.display === "mensagemingdesk"
                                    ) {
                                      if (
                                        notifier.ingdesk_data.display ===
                                        "caseAlert"
                                      ) {
                                        return <UserEdit />;
                                      } else {
                                        return <TarefasIcon />;
                                      }
                                    }
                                  })()}
                                  <p
                                    className="item-notification__content__title"
                                    onClick={(event) =>
                                      this.ShowInfoDisplay(
                                        event,
                                        notifier.display,
                                        notifier.remote,
                                        screenprevious,
                                        `${
                                          notifier.ingdesk_data &&
                                          notifier.ingdesk_data.display ===
                                            "caseAlert"
                                            ? "casos/" + notifier.remote
                                            : "tarefas/" + notifier.idnotifier
                                        }`,
                                        notifier.ingdesk_data,
                                      )
                                    }
                                  >
                                    <span className="item-notification__content__title__name">
                                      {notifier.author}
                                      {notifier.display === "mensagemingdesk"
                                        ? `: ${notifier.description[0].title}`
                                        : ""}
                                    </span>

                                    <span className="item-notification__content__title__time">
                                      {notifier.display === "mensagemingdesk"
                                        ? notifier.description[0].deadline
                                        : data}
                                    </span>
                                  </p>
                                </div>
                                <div className="item-notification__content-description">
                                  <span>
                                    {notifier.display === "mensagemingdesk"
                                      ? notifier.description[0].task
                                      : notifier.description}
                                  </span>
                                  <button
                                    onClick={(e) => {
                                      this.RemoveNotifier(
                                        e,
                                        notifier.remote,
                                        notifier.ingdesk_data,
                                      );
                                      e.stopPropagation();
                                    }}
                                    className="btn--text"
                                  >
                                    Dispensar
                                  </button>
                                </div>
                              </div>
                            );
                          }
                        })()}
                      </div>
                    );
                  })(),
                )
            ) : (
              <div className="empty-space_notifier">
                <div className="icon-empty">
                  <NotificationIcon />
                </div>
                <div className="empty-message">
                  Você não tem nenhuma notificação.
                </div>
              </div>
            )}
            {/* <!-- end item --> */}

            {/* <!-- item notification --> */}
            {/* <div className="item-notification item-notification--event">
                  <div className="item-notification__content">
                    <i className="material-icons">insert_invitation</i>
                    <p className="item-notification__content__title">
                      <span className="item-notification__content__title item-notification__content__title__name">Lorem</span>
                      lembrete 1
                      <span className="item-notification__content__title item-notification__content__title__time">(38min)</span>
                      <button className="btn--text">Dispensar</button>
                    </p>
                  </div>    
                        
                </div>  */}
            {/* <!-- end item --> */}
          </div>
        </li>
        {/* className="acoes__item acoes__item__notification" */}
      </ul>
    </div>
  );

  handlePositionPopUp(valor, label, position) {
    const { InfoUsers } = this.props;
    localStorage.setItem(
      "position-popup",
      JSON.stringify({ index: valor, label: label, position: position }),
    );
    this.setState({ popupValue: { index: valor, label: label } });
    this.FilterDispPopUp();
    toast.custom(
      <div className="calling-popup">
        <div className="calling-popup__close">
          <div
            className="calling-popup__close-button"
            onClick={() => closeToast()}
          >
            <IconClose />
          </div>
        </div>
        <div className="calling-popup__infos">
          <UserPhoto
            size="extra-large"
            link={InfoUsers.userImg ? InfoUsers.userImg : false}
          />
          <div className="calling-popup__infos-container">
            <span className="calling-popup__infos-item"></span>
            <span className="calling-popup__infos-item">
              {InfoUsers.ramal} - {InfoUsers.displayname}
            </span>
            <span className="calling-popup__infos-calling">Chamando...</span>
          </div>
        </div>
        <div className="calling-popup__actions">
          <div className="calling-popup__actions-buttons recuse">
            <IconRecuseCall />
          </div>
          <div className="calling-popup__actions-buttons mute">
            <IconMute />
          </div>
          <div className="calling-popup__actions-buttons answer">
            <IconAnswerCall />
          </div>
        </div>
      </div>,
      {
        duration: 2000,
        position: position,
      },
    );
  }

  renderPopoverSettings = (
    e,
    IPCurrent,
    RegisterNotifier,
    screenprevious,
    DeviceList,
    DeviceListDefault,
  ) => (
    <div className={"settings-main"}>
      <div
        className="settings-main__title"
        onClick={(e) =>
          this.setState({
            buttonshowlessoption: !this.state.buttonshowlessoption,
          })
        }
      >
        <h2 className="settings-main__title__text">
          Configurações de dispositivos
        </h2>
      </div>

      <div className="settings-main__body">
        <div className="settings-main__config-voice">
          <h3 className="settings-main__subtitle">Configurações de voz</h3>
          <div className="principal_config-voice">
            <div className="principal_config-voice__item">
              <span className="item-config__title">Entrada</span>
              <div className="principal_config-voice_principal">
                <button
                  onClick={(event) => this.FilterDispEnt(event)}
                  className={
                    this.state.buttondispEnt
                      ? "principal_config-voice-btn active"
                      : "principal_config-voice-btn"
                  }
                >
                  <span>{this.state.descdeviceent}</span>

                  <i className="material-icons">chevron_right</i>
                </button>
                <div
                  className={
                    this.state.buttondispEnt
                      ? "principal_config-voice__select active"
                      : "principal_config-voice__select"
                  }
                >
                  <ul className="pausa__list">
                    {DeviceList.map((device, index) =>
                      (() => {
                        if (parseInt(device.dispositivo) === 0) {
                          return (
                            <li
                              key={index}
                              className="pausa__item"
                              onClick={(event) =>
                                this.getSetDeviceEnt(event, 0, device.descricao)
                              }
                            >
                              <p className="pausa__label">{device.descricao}</p>
                            </li>
                          );
                        }
                      })(),
                    )}
                  </ul>
                </div>
              </div>
            </div>

            <div className="principal_config-voice__item">
              <span className="item-config__title">Saída</span>
              <div className="principal_config-voice_principal">
                <button
                  className="principal_config-voice-btn"
                  onClick={(event) => this.FilterDispSaida(event)}
                >
                  <span>{this.state.descdevicesaida}</span>
                  <i className="material-icons">chevron_right</i>
                </button>
                <div
                  className={
                    this.state.buttonDispSaida
                      ? "principal_config-voice__select active"
                      : "principal_config-voice__select"
                  }
                >
                  <ul className="pausa__list">
                    {DeviceList.map((device) =>
                      (() => {
                        if (parseInt(device.dispositivo) === 1) {
                          return (
                            <li
                              key={keycount++}
                              className="pausa__item"
                              onClick={(event) =>
                                this.getSetDeviceSaida(
                                  event,
                                  1,
                                  device.descricao,
                                )
                              }
                            >
                              <p className="pausa__label">{device.descricao}</p>
                            </li>
                          );
                        }
                      })(),
                    )}
                  </ul>
                </div>
              </div>
            </div>

            {/* <div className="principal_config-voice__item">
              <span className="item-config__title">Ringing</span>
              <div className="principal_config-voice_principal">
                <button
                  className="principal_config-voice-btn"
                  onClick={(event) => this.FilterDispRing(event)}
                >
                  {this.state.descdevicering}
                  <i className="material-icons">chevron_right</i>
                </button>
                <div
                  className={
                    this.state.buttondispRing
                      ? "principal_config-voice__select active"
                      : "principal_config-voice__select"
                  }
                >
                  <ul className="pausa__list">
                    {DeviceList.map((device) =>
                      (() => {
                        if (parseInt(device.dispositivo) === 2) {
                          return (
                            <li
                              key={keycount++}
                              className="pausa__item"
                              onClick={(event) =>
                                this.getSetDeviceRing(
                                  event,
                                  2,
                                  device.descricao
                                )
                              }
                            >
                              <p className="pausa__label">{device.descricao}</p>
                            </li>
                          );
                        }
                      })()
                    )}
                  </ul>
                </div>
              </div>
            </div> */}

            {/* <div className="principal_config-voice__item">
              <span className="item-config__title">Número de ring</span>
              <div className="principal_config-voice_principal">
                <button className="principal_config-voice-btn no-options">
                  ...
                  <i className="material-icons">chevron_right</i>
                </button>
                <div className="principal_config-voice__select">
                  <ul className="pausa__list">
                    <li className="pausa__item">
                      <p className="pausa__label">Almoço 1.5h</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div> */}
          </div>
          {/* <!-- end items -->             */}
        </div>

        <div className="settings-main__config-popup">
          <h3 className="settings-main__subtitle">Pop-up de atendimento</h3>
          <div className="principal_config-popup">
            <div className="principal_config-popup__item">
              <span className="item-config__title">Posicionamento</span>
              <div className="principal_config-popup_principal">
                <button
                  onClick={(event) => this.FilterDispPopUp(event)}
                  className={
                    this.state.popupSelect
                      ? "principal_config-popup-btn active"
                      : "principal_config-popup-btn"
                  }
                >
                  {this.state.popupValue.label
                    ? this.state.popupValue.label
                    : "Selecione a posição..."}

                  <i className="material-icons">chevron_right</i>
                </button>
                <div
                  className={
                    this.state.popupSelect
                      ? "principal_config-popup__select active"
                      : "principal_config-popup__select"
                  }
                >
                  <ul className="pausa__list">
                    <li
                      key={0}
                      className={`pausa__item ${
                        this.state.popupValue.index === 0 ? "active" : ""
                      }`}
                      onClick={(event) =>
                        this.handlePositionPopUp(
                          0,
                          "Superior direito",
                          "top-right",
                        )
                      }
                    >
                      <SuperiorDireito />
                      <p className="pausa__label">Superior direito</p>
                    </li>
                    <li
                      key={1}
                      className={`pausa__item ${
                        this.state.popupValue.index === 1 ? "active" : ""
                      }`}
                      onClick={(event) =>
                        this.handlePositionPopUp(
                          1,
                          "Centro superior",
                          "top-center",
                        )
                      }
                    >
                      <CentroSuperior />
                      <p className="pausa__label">Centro superior</p>
                    </li>
                    <li
                      key={2}
                      className={`pausa__item ${
                        this.state.popupValue.index === 2 ? "active" : ""
                      }`}
                      onClick={(event) =>
                        this.handlePositionPopUp(
                          2,
                          "Superior esquerdo",
                          "top-left",
                        )
                      }
                    >
                      <SuperiorEsquerdo />
                      <p className="pausa__label">Superior esquerdo</p>
                    </li>
                    <li
                      key={3}
                      className={`pausa__item ${
                        this.state.popupValue.index === 3 ? "active" : ""
                      }`}
                      onClick={(event) =>
                        this.handlePositionPopUp(
                          3,
                          "Inferior direito",
                          "bottom-right",
                        )
                      }
                    >
                      <InferiorDireito />
                      <p className="pausa__label">Inferior direito</p>
                    </li>
                    <li
                      key={4}
                      className={`pausa__item ${
                        this.state.popupValue.index === 4 ? "active" : ""
                      }`}
                      onClick={(event) =>
                        this.handlePositionPopUp(
                          4,
                          "Centro inferior",
                          "bottom-center",
                        )
                      }
                    >
                      <CentroInferior />
                      <p className="pausa__label">Centro inferior</p>
                    </li>
                    <li
                      key={5}
                      className={`pausa__item ${
                        this.state.popupValue.index === 5 ? "active" : ""
                      }`}
                      onClick={(event) =>
                        this.handlePositionPopUp(
                          5,
                          "Inferior esquerdo",
                          "bottom-left",
                        )
                      }
                    >
                      <InferiorEsquerdo />
                      <p className="pausa__label">Inferior esquerdo</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="settings-main__processing-voice">
          <h3 className="settings-main__subtitle">Processamento de voz</h3>
          <div className="principal_processing-voice">
            <div className="principal_processing-voice__item">
              <label>
                Cancelamento de eco
                <Checkbox
                  typeCheck="checkbox"
                  id="echo_canceler"
                  defaultChecked={true}
                  onClick={(event) => this.ChangeEchoCanceler(event)}
                />
                {/* <input
                  type="checkbox"
                  id="echo_canceler"
                  defaultChecked={true}
                  onClick={(event) => this.ChangeEchoCanceler(event)}
                /> */}
              </label>
            </div>
            <div className="principal_processing-voice__item">
              <label>
                Intensificador de microfone
                <Checkbox typeCheck="checkbox" id="c2" />
                {/* <input type="checkbox" id="c2" /> */}
              </label>
            </div>
            <div className="principal_processing-voice__item">
              <label>
                Aviso sonoro ao receber mensagens
                <Checkbox
                  typeCheck="checkbox"
                  id="c3"
                  title="Aviso sonoro de recebimento de mensagem"
                  defaultChecked={IPCurrent.audiomessage}
                  onClick={(event) => this.ChangeAudioMessage(event, IPCurrent)}
                />
                {/* <input
                  type="checkbox"
                  id="c3"
                  title="Aviso sonoro de recebimento de mensagem"
                  defaultChecked={IPCurrent.audiomessage}
                  onClick={(event) => this.ChangeAudioMessage(event, IPCurrent)}
                /> */}
              </label>
            </div>
            <div className="principal_processing-voice__item">
              <label>
                Aviso sonoro de interação
                <Checkbox
                  typeCheck="checkbox"
                  defaultChecked={IPCurrent.audio}
                  id="c31"
                  name="c31"
                  onClick={(event) => this.InputOutputAudio(event, IPCurrent)}
                />
                {/* <input
                  type="checkbox"
                  defaultChecked={IPCurrent.audio}
                  id="c31"
                  name="c31"
                  onClick={(event) => this.InputOutputAudio(event, IPCurrent)}
                /> */}
              </label>
            </div>
            <div className="principal_processing-voice__item">
              <label>
                Aviso sonoro de chamada em fila
                <Checkbox
                  typeCheck="checkbox"
                  defaultChecked={IPCurrent.audiocall}
                  id="c32"
                  name="c32"
                  onClick={(event) =>
                    this.InputOutputAudioCall(event, IPCurrent)
                  }
                />
              </label>
            </div>
          </div>
        </div>

        <div className="settings-main__volume">
          <h3 className="settings-main__subtitle">Volume</h3>
          <div className="principal-volume">
            <div className="range-slider">
              <div className="range-content__title item-config__title item-config__title--dark">
                Microfone
              </div>
              <div
                className="range-content__body"
                id="range_microfone"
                onChange={() => generateResult("volume_microfone", 0)}
              >
                <MicrophoneIcon />
                <input
                  type="range"
                  id="volume_microfone"
                  className="range-slider__range"
                  min="0"
                  max="100"
                  step="2"
                  style={{
                    progressRange: "50%",
                    background:
                      this.props.InfoDisplay.infodisplay === "Monitorias"
                        ? "linear-gradient(90deg, #FFFFFF 50%, #BFC3CA 50.1%)"
                        : "linear-gradient(90deg, #455CC7 50%, #BFC3CA 50.1%)",
                  }}
                />
              </div>
            </div>

            <div className="range-slider">
              <div className="range-content__title item-config__title item-config__title--dark">
                Fones
              </div>
              <div
                className="range-content__body"
                id="range_saida"
                onChange={() => generateResult("volume_saida", 1)}
              >
                <HeadphoneIcon />
                <input
                  type="range"
                  id="volume_saida"
                  className="range-slider__range"
                  min="0"
                  max="100"
                  step="2"
                  style={{
                    progressRange: "50%",
                    background:
                      this.props.InfoDisplay.infodisplay === "Monitorias"
                        ? "linear-gradient(90deg, #FFFFFF 50%, #BFC3CA 50.1%)"
                        : "linear-gradient(90deg, #455CC7 50%, #BFC3CA 50.1%)",
                  }}
                />
              </div>
            </div>

            <div className="range-slider">
              <div className="range-content__title item-config__title item-config__title--dark">
                Notificações
              </div>
              <div
                className="range-content__body"
                id="range_ring"
                onChange={() => generateResult("volume_ring", 2)}
              >
                <NotificationIcon />
                <input
                  type="range"
                  id="volume_ring"
                  className="range-slider__range"
                  min="0"
                  max="100"
                  step="2"
                  style={{
                    progressRange: "50%",
                    background:
                      this.props.InfoDisplay.infodisplay === "Monitorias"
                        ? "linear-gradient(90deg, #FFFFFF 50%, #BFC3CA 50.1%)"
                        : "linear-gradient(90deg, #455CC7 50%, #BFC3CA 50.1%)",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  insert_pause_automatic(idPause) {
    if (
      document.getElementById(`reason-${idPause}`) &&
      document.getElementById("click_pause_automatic")
    ) {
      document.getElementById(`reason-${idPause}`).click();
      document.getElementById("click_pause_automatic").click();
    }
  }

  click_pause(event, InfoUsers, StatusAgent, datalogin, Reasons) {
    var reason = Reasons[0];
    this.InsertPause(
      event,
      InfoUsers,
      datalogin,
      reason.name,
      reason.id,
      "BQ",
      reason.logout,
      reason.isdescription,
      reason.allow_use,
      StatusAgent,
      reason.durationmaxblock,
      reason.durationminblock,
    );
  }

  CaptureCall(e, infousers) {
    // MicroModal.show('modal__capture-fail');
    const socket = CaptureCallSocket(infousers);
  }

  getSetDeviceEnt(e, action, descdeviceE) {
    webphone_api.setdevice(0, descdeviceE, 2);
    localStorage.setItem("device_microfone", descdeviceE);
    let deviceEnt = descdeviceE.substring(0, 15);
    this.setState({
      descdeviceent: deviceEnt,
      buttondispEnt: !this.state.buttondispEnt,
    });
    this.props.getDeviceMicrofone(descdeviceE);
  }

  getSetDeviceSaida(e, action, descdeviceS) {
    webphone_api.setdevice(1, descdeviceS, 2);
    localStorage.setItem("device_audio", descdeviceS);
    let deviceSaida = descdeviceS.substring(0, 15);
    this.setState({
      descdevicesaida: deviceSaida,
      buttonDispSaida: !this.state.buttonDispSaida,
    });
    this.props.getDeviceAudio(descdeviceS);
  }

  getSetDeviceRing(e, action, descdeviceR) {
    webphone_api.setdevice(2, descdeviceR, 2);
    localStorage.setItem("device_ring", descdeviceR);
    let deviceRing = descdeviceR.substring(0, 15);
    this.setState({
      descdevicering: deviceRing,
      buttondispRing: !this.state.buttondispRing,
    });
    this.props.getDeviceRing(descdeviceR);
  }

  showUserMidia() {
    // MicroModal.show('modal__usermidia')
  }

  ContinueSup(event, InfoUsers, StatusAgent) {
    this.props.nc2Disabled();

    this.FunctionInsertPause(
      event,
      InfoUsers,
      datalogin,
      "Livre",
      -1,
      "LV",
      "false",
      "false",
      "false",
      StatusAgent,
    );
    nc2Enable = false;
  }

  renderPopoverStatus = (InfoUsers, StatusAgent, ContactId, AtdSimult) => {
    const disableFreeStatus =
      !!AtdSimult &&
      Array.isArray(AtdSimult) &&
      AtdSimult.length > 0 &&
      InfoUsers.blockscreen !== "Bloqueado";
    return (
      <div className={"pausa__select active"}>
        <p className="pausa__list-title">Selecione um status</p>
        <ul className="pausa__list max-h">
          <li
            className={
              this.state.disabled
                ? `pausa__item active ${
                    disableFreeStatus ? "disable-free-status" : ""
                  }`
                : `pausa__item ${
                    disableFreeStatus ? "disable-free-status" : ""
                  }`
            }
            onClick={(event) => {
              if (disableFreeStatus) {
                return;
              }
              return this.InsertPause(
                event,
                InfoUsers,
                datalogin,
                "Livre",
                "-1",
                "LV",
                "false",
                false,
                true,
                StatusAgent,
                0,
                null,
                ContactId,
              );
            }}
          >
            <span className="pausa-btn__icon pausa-btn--livre"></span>
            <p className="pausa__label">
              {" "}
              {InfoUsers.blockscreen ? "Bloqueado" : "Livre"}
            </p>
          </li>
          {this.state.reasons.map((reason) =>
            (() => {
              if (reason.logout === false) {
                return (
                  <li
                    key={reason.id}
                    id={`reason-${reason.id}`}
                    className={
                      this.state.buttonPauseDis &&
                      this.state.PausaId === reason.id
                        ? "pausa__item active"
                        : "pausa__item"
                    }
                    onClick={(event) => {
                      this.InsertPause(
                        event,
                        InfoUsers,
                        datalogin,
                        reason.name,
                        reason.id,
                        "BQ",
                        reason.logout,
                        reason.isdescription,
                        reason.allow_use,
                        StatusAgent,
                        reason.durationmaxblock,
                        reason.durationminblock,
                        ContactId,
                      );
                      this.setState({
                        reasonLogoutSelected: [],
                      });
                    }}
                  >
                    <span className="pausa-btn__icon pausa-btn--pausado"></span>
                    <p className="pausa__label"> {reason.name}</p>
                  </li>
                );
              }
            })(),
          )}
        </ul>
        <hr className="pausa__divider" />
        <ul className="pausa__list">
          {this.state.reasons.map((reason) =>
            (() => {
              if (reason.logout === true) {
                return (
                  <li
                    key={reason.id}
                    className={
                      this.state.buttonPauseDis &&
                      this.state.PausaId === reason.id
                        ? "pausa__item active"
                        : "pausa__item"
                    }
                    onClick={(event) => {
                      this.InsertPause(
                        event,
                        InfoUsers,
                        datalogin,
                        reason.name,
                        reason.id,
                        "BQ",
                        reason.logout,
                        reason.isdescription,
                        reason.allow_use,
                        StatusAgent,
                        reason.durationmaxblock,
                        reason.durationminblock,
                        ContactId,
                      );
                      this.setState({
                        reasonLogoutSelected: [
                          { ...reason, label: reason.name },
                        ],
                      });
                    }}
                  >
                    <span className="pausa-btn__icon pausa-btn--pausado"></span>
                    <p className="pausa__label"> {reason.name}</p>
                  </li>
                );
              }
            })(),
          )}
        </ul>
      </div>
    );
  };

  handleTypePassword(inputNumber) {
    switch (inputNumber) {
      case 1:
        this.setState({ changeTypePassword1: !this.state.changeTypePassword1 });
        break;
      case 2:
        this.setState({ changeTypePassword2: !this.state.changeTypePassword2 });
        break;
      case 3:
        this.setState({ changeTypePassword3: !this.state.changeTypePassword3 });
        break;
      default:
        break;
    }
  }

  handleChange(event, inputValue) {
    const msgAlerta1 = document.getElementById("msg_erro1");
    const msgAlerta2 = document.getElementById("msg_erro2");
    const msgAlerta3 = document.getElementById("msg_erro3");

    switch (inputValue) {
      case "password":
        this.setState({
          valuePasswords: {
            password: event.target.value,
            passwordNew: this.state.valuePasswords.passwordNew,
            passwordNewRep: this.state.valuePasswords.passwordNewRep,
          },
        });
        msgAlerta1.innerHTML = "";
        msgAlerta1.classList.remove("error");
        break;
      case "passwordNew":
        this.setState({
          valuePasswords: {
            password: this.state.valuePasswords.password,
            passwordNew: event.target.value,
            passwordNewRep: this.state.valuePasswords.passwordNewRep,
          },
        });
        msgAlerta2.innerHTML = "";
        msgAlerta2.classList.remove("error");
        break;
      case "passwordNewRep":
        this.setState({
          valuePasswords: {
            password: this.state.valuePasswords.password,
            passwordNew: this.state.valuePasswords.passwordNew,
            passwordNewRep: event.target.value,
          },
        });
        msgAlerta3.innerHTML = "";
        msgAlerta3.classList.remove("error");
        break;

      default:
        break;
    }
  }

  handleClearInfos() {
    const msgAlerta1 = document.getElementById("msg_erro1");
    const msgAlerta2 = document.getElementById("msg_erro2");
    const msgAlerta3 = document.getElementById("msg_erro3");

    msgAlerta1.innerHTML = "";
    msgAlerta2.innerHTML = "";
    msgAlerta3.innerHTML = "";
    if (msgAlerta3.classList.contains("error")) {
      msgAlerta3.classList.remove("error");
    }
    if (msgAlerta2.classList.contains("error")) {
      msgAlerta2.classList.remove("error");
    }
    if (msgAlerta1.classList.contains("error")) {
      msgAlerta1.classList.remove("error");
    }

    this.setState({
      valuePasswords: {
        password: "",
        passwordNew: "",
        passwordNewRep: "",
      },
    });
  }

  changePassword(event, bind) {
    const pathName = !!localStorage.getItem("pathname")
      ? localStorage.getItem("pathname")
      : connection_platform.ip_extern;
    const newPort = !!localStorage.getItem("port")
      ? localStorage.getItem("port")
      : connection_platform.port_backend_intern;
    event.preventDefault();
    if (!connection_platform.multitenancy) {
      const { InfoUsers } = bind.props;
      const { password, passwordNew, passwordNewRep } =
        bind.state.valuePasswords;
      const msgAlerta1 = document.getElementById("msg_erro1");
      const msgAlerta2 = document.getElementById("msg_erro2");
      const msgAlerta3 = document.getElementById("msg_erro3");

      var regex = /^(?=.*[A-Z])(?=.*[!@#$%^&*.])(.{8,})$/;
      var checkPassword = regex.test(passwordNewRep);

      if (!password || !passwordNew || !passwordNewRep) {
        if (!password) {
          msgAlerta1.innerHTML = "Digite uma senha de 6 caracteres";
        }
        if (!passwordNew) {
          msgAlerta2.innerHTML = "Digite uma senha de 6 caracteres";
        }
        if (!passwordNewRep) {
          msgAlerta3.innerHTML = "Digite uma senha de 6 caracteres";
        }

        return;
      }

      if (
        (password && password.length < 6) ||
        (passwordNew && passwordNew.length < 6) ||
        (passwordNewRep && passwordNewRep.length < 6)
      ) {
        if (password && password.length < 6) {
          msgAlerta1.innerHTML = "Digite uma senha de 6 caracteres";
        }
        if (passwordNew && passwordNew.length < 6) {
          msgAlerta2.innerHTML = "Digite uma senha de 6 caracteres";
        }
        if (passwordNewRep && passwordNewRep.length < 6) {
          msgAlerta3.innerHTML = "Digite uma senha de 6 caracteres";
        }

        return;
      }

      if (passwordNew && passwordNewRep && passwordNew !== passwordNewRep) {
        msgAlerta3.innerHTML = "Está senha não é igual.";
        msgAlerta3.classList.add("error");
        return;
      }

      if (
        password &&
        passwordNew &&
        passwordNewRep &&
        passwordNew === password
      ) {
        msgAlerta2.innerHTML = "A senha nova não pode ser igual a anterior.";
        msgAlerta2.classList.add("error");
        return;
      }

      if (!checkPassword) {
        msgAlerta2.innerHTML =
          "Nova senha deve conter pelo menos uma letra maiúscula, um caractere especial e ter no mínimo 8 caracteres.";
        msgAlerta2.classList.add("error");
        msgAlerta3.innerHTML =
          "Nova senha deve conter pelo menos uma letra maiúscula, um caractere especial e ter no mínimo 8 caracteres.";
        msgAlerta3.classList.add("error");

        return;
      }

      if (
        password &&
        passwordNew &&
        passwordNewRep &&
        passwordNew === passwordNewRep &&
        checkPassword
      ) {
        return axios
          .get(
            `${
              connection_platform.type_connect
            }://${pathName}:${newPort}/conn/password?username=${
              InfoUsers.email
            }&password=${md5(password)}`,
          )
          .then((response) => {
            if (response.data !== "") {
              return axios
                .get(
                  `${connection_platform.type_connect}://${pathName}:${newPort}/conn/updatepassword?id=${InfoUsers.id}&newpassword=` +
                    md5(passwordNew),
                )
                .then((response) => {
                  if (response.data !== "") {
                    toast.custom(
                      <div className="container__change-password_sucess">
                        <div className="container__change-password__icon">
                          <CheckSucessIcon />
                        </div>
                        <div className="container__change-password__separator">
                          <div className="container__change-password__box">
                            <strong>Senha alterada com sucesso!</strong>
                            <div
                              className="container__change-password__box-icon"
                              onClick={() => closeToast()}
                            >
                              <IconClose />
                            </div>
                          </div>
                        </div>
                      </div>,
                      {
                        duration: 5000,
                        position: "bottom-left",
                      },
                    );
                    // this.setState({ verifyError: false });
                    document.querySelector(".button_cancel").click();

                    // this.CloseModal("modalactions");
                  }
                });
            } else {
              msgAlerta1.innerHTML =
                "Senha não confere, por favor digite corretamente.";
              msgAlerta1.classList.add("error");
            }
          })
          .catch((error) => {
            this.props.WarningErro(true, false, true, error);
          });
      }
    } else {
      let port = connection_platform.port_backend_intern;
      if (pathname !== connection_platform.ip_intern) {
        port = connection_platform.port_backend_extern;
      }

      const auxPort = localStorage.getItem("port");

      if (auxPort) {
        port = auxPort;
      }

      const { InfoUsers } = bind.props;
      const { password, passwordNew, passwordNewRep } =
        bind.state.valuePasswords;
      const msgAlerta1 = document.getElementById("msg_erro1");
      const msgAlerta2 = document.getElementById("msg_erro2");
      const msgAlerta3 = document.getElementById("msg_erro3");

      var regex = /^(?=.*[A-Z])(?=.*[!@#$%^&*.])(.{8,})$/;
      var checkPassword = regex.test(passwordNewRep);

      if (!password || !passwordNew || !passwordNewRep) {
        if (!password) {
          msgAlerta1.innerHTML = "Digite uma senha de 6 caracteres";
        }
        if (!passwordNew) {
          msgAlerta2.innerHTML = "Digite uma senha de 6 caracteres";
        }
        if (!passwordNewRep) {
          msgAlerta3.innerHTML = "Digite uma senha de 6 caracteres";
        }

        return;
      }

      if (
        (password && password.length < 6) ||
        (passwordNew && passwordNew.length < 6) ||
        (passwordNewRep && passwordNewRep.length < 6)
      ) {
        if (password && password.length < 6) {
          msgAlerta1.innerHTML = "Digite uma senha de 6 caracteres";
        }
        if (passwordNew && passwordNew.length < 6) {
          msgAlerta2.innerHTML = "Digite uma senha de 6 caracteres";
        }
        if (passwordNewRep && passwordNewRep.length < 6) {
          msgAlerta3.innerHTML = "Digite uma senha de 6 caracteres";
        }

        return;
      }

      if (passwordNew && passwordNewRep && passwordNew !== passwordNewRep) {
        msgAlerta3.innerHTML = "Está senha não é igual.";
        msgAlerta3.classList.add("error");
        return;
      }

      if (
        password &&
        passwordNew &&
        passwordNewRep &&
        passwordNew === password
      ) {
        msgAlerta2.innerHTML = "A senha nova não pode ser igual a anterior.";
        msgAlerta2.classList.add("error");
        return;
      }

      if (!checkPassword) {
        msgAlerta2.innerHTML =
          "Nova senha deve conter pelo menos uma letra maiúscula, um caractere especial e ter no mínimo 8 caracteres.";
        msgAlerta2.classList.add("error");
        msgAlerta3.innerHTML =
          "Nova senha deve conter pelo menos uma letra maiúscula, um caractere especial e ter no mínimo 8 caracteres.";
        msgAlerta3.classList.add("error");

        return;
      }

      if (
        password &&
        passwordNew &&
        passwordNewRep &&
        passwordNew === passwordNewRep &&
        checkPassword
      ) {
        return axios
          .get(
            `${
              connection_platform.type_connect
            }://${pathName}:${newPort}/conn/password?username=${
              InfoUsers.email
            }&password=${md5(password)}`,
          )
          .then((response) => {
            if (response.data !== "") {
              return axios
                .get(
                  `${connection_platform.type_connect}://${pathName}:${newPort}/conn/updatepassword?id=${InfoUsers.id}&newpassword=` +
                    md5(passwordNew),
                )
                .then((response) => {
                  if (response.data !== "") {
                    toast.custom(
                      <div className="container__change-password_sucess">
                        <div className="container__change-password__icon">
                          <CheckSucessIcon />
                        </div>
                        <div className="container__change-password__separator">
                          <div className="container__change-password__box">
                            <strong>Senha alterada com sucesso!</strong>
                            <div
                              className="container__change-password__box-icon"
                              onClick={() => closeToast()}
                            >
                              <IconClose />
                            </div>
                          </div>
                        </div>
                      </div>,
                      {
                        duration: 5000,
                        position: "bottom-left",
                      },
                    );
                    // this.setState({ verifyError: false });
                    document.querySelector(".button_cancel").click();

                    // this.CloseModal("modalactions");
                  }
                });
            } else {
              msgAlerta1.innerHTML =
                "Senha não confere, por favor digite corretamente.";
              msgAlerta1.classList.add("error");
            }
          })
          .catch((error) => {
            this.props.WarningErro(true, false, true, error);
          });
      }
    }

    //InfoUsers.error
  }

  render() {
    const {
      InfoDisplay,
      ReasonsBlock,
      InfoUsers,
      ServiceID,
      ContactId,
      StatusAgent,
      QueuePermission,
      AtdSimult,
      IPCurrent,
      RegisterNotifier,
      CurrentScreen,
      AutomaticPause,
      DeviceList,
      DeviceListDefault,
      ReasonsBlockSup,
      ServiceURL,
      confirmChange,
    } = this.props;
    const { status } = this.state;
    if (connection_platform.client_personalized === 0) {
      if (InfoDisplay.infodisplay === "Monitorias") {
        logoCarregada = LogoDark;
      } else {
        logoCarregada = Logo;
      }
    } else if (connection_platform.client_personalized === 1) {
      //SMARTERS
      if (InfoDisplay.infodisplay === "Monitorias") {
        logoCarregada = LogoDarkSmarters;
      } else {
        logoCarregada = LogoSmarters;
      }
    }

    //ERRORDB-PAUSAFUTURA
    // this.setState({
    //   displayfuture:
    //     InfoUsers.blockfuture === true
    //       ? "pausa__futura-btn active"
    //       : "pausa__futura-btn",
    // });

    if (InfoUsers.blockfuture === true) {
      this.setDisplayfuture(true);
    } else {
      this.setDisplayfuture(false);
    }

    if (InfoUsers.blocknc2 && nc2Enable === false) {
      if (InfoUsers.mensagemnc2 === "Estado Inconsistente") {
        if (ReasonsBlockSup.reasons.length !== 0) {
          ReasonsBlockSup.reasons.map((reasons) => {
            if (reasons.reason_block_type_id === 4) {
              this.props.ByeAtendantts(ContactId.idatendimento);

              this.FunctionInsertPause(
                "event",
                InfoUsers,
                datalogin,
                reasons.name,
                reasons.id,
                InfoUsers.status,
                false,
                false,
                false,
                InfoUsers.status,
                reasons.durationmaxblock,
                reasons.durationminblock,
              );
              nc2Enable = true;
            }
          });
        }
      } else if (InfoUsers.mensagemnc2 === "Sem mailing") {
        if (ReasonsBlockSup.reasons.length !== 0) {
          ReasonsBlockSup.reasons.map((reasons) => {
            if (reasons.reason_block_type_id === 3) {
              this.props.ByeAtendantts(ContactId.idatendimento);
              this.FunctionInsertPause(
                "event",
                InfoUsers,
                datalogin,
                reasons.name,
                reasons.id,
                InfoUsers.status,
                false,
                false,
                false,
                InfoUsers.status,
                reasons.durationmaxblock,
                reasons.durationminblock,
              );
              nc2Enable = true;
            }
          });
        }
      } else if (InfoUsers.mensagemnc2 === "Fluxo interrompido!") {
        if (ReasonsBlockSup.reasons.length !== 0) {
          ReasonsBlockSup.reasons.map((reasons) => {
            if (reasons.reason_block_type_id === 4) {
              this.props.ByeAtendantts(ContactId.idatendimento);
              this.FunctionInsertPause(
                "event",
                InfoUsers,
                datalogin,
                reasons.name,
                reasons.id,
                InfoUsers.status,
                false,
                false,
                false,
                InfoUsers.status,
                reasons.durationmaxblock,
                reasons.durationminblock,
              );
              nc2Enable = true;
            }
          });
        }
      }
    }

    if (StatusAgent.reason === "Bloqueado") {
      this.state.status = StatusAgent.reason;
    }

    if (
      StatusAgent.status != undefined &&
      this.state.auxstatus != StatusAgent.status
    ) {
      if (StatusAgent.status === "Pausado") {
        this.FinishAtendant(StatusAgent.status, ContactId);
      }
      if (StatusAgent.status === "Livre") {
        this.FinishAtendant(StatusAgent.status, ContactId);
        this.state.status = "Livre";
        this.state.PausaId = -1;
      }
      if (
        StatusAgent.status === "Atendimento" ||
        StatusAgent.status === "Ligação" ||
        StatusAgent.status === "Discando" ||
        StatusAgent.status === "Chamando" ||
        StatusAgent.status === "Aftercallwork"
      ) {
        this.FinishAtendant(StatusAgent.status, ContactId, IPCurrent);
        this.state.status = StatusAgent.status;
      }

      if (StatusAgent.status === "Encerrou") {
        this.FinishAtendant(StatusAgent.status, ContactId);
        this.SetBlockFuture(InfoUsers, datalogin, AtdSimult, StatusAgent);
        if (ContactId.serviceatd && parseInt(ContactId.idmidia) != 1) {
          this.UpdateToServiceAtd(ContactId.serviceatd);
        }
        //this.VerifiedReturn(CallBack,InfoUsers, ContactId, QueuePermission, DisplayNextAtd.displaynextatdtemp)
      }

      if (StatusAgent.status === "EncerrouDiscagem") {
        this.FinishAtendant(StatusAgent.status, ContactId);
        this.SetBlockFuture(InfoUsers, datalogin, AtdSimult, StatusAgent);
      }

      if (StatusAgent.status === "Deslogue") {
        this.LogoutSup();
      }
    }

    if (AtdSimult.length != 0) {
      this.state.atdsimult = AtdSimult;
    }

    if (DeviceListDefault.length !== 0) {
      DeviceListDefault.filter((person) => person.dispositivo === 0).map(
        (filteredPerson) =>
          (this.state.descdeviceent =
            this.state.descdeviceent !== ""
              ? this.state.descdeviceent
              : filteredPerson.descricao.substring(0, 15)),
      );

      DeviceListDefault.filter((person) => person.dispositivo === 1).map(
        (filteredPerson) =>
          (this.state.descdevicesaida =
            this.state.descdevicesaida !== ""
              ? this.state.descdevicesaida
              : filteredPerson.descricao.substring(0, 15)),
      );

      DeviceListDefault.filter((person) => person.dispositivo === 2).map(
        (filteredPerson) =>
          (this.state.descdevicering =
            this.state.descdevicering !== ""
              ? this.state.descdevicering
              : filteredPerson.descricao.substring(0, 15)),
      );
    }

    if (RegisterNotifier.length != 0) {
      this.state.registernotifier = RegisterNotifier;
      this.state.registernotifier = this.state.registernotifier
        .filter((register) => register.display !== "mensagememail")
        .filter((not) => this.state.filter.includes(not.task));
      this.state.tamanho = this.state.registernotifier.length;
      // this.state.registernotifier = this.state.registernotifier.slice(0, 4);
    } else {
      this.state.registernotifier = [];
    }

    if (IPCurrent.length != 0) {
      if (IPCurrent.audio === true) {
        this.state.buttonNotifier = true;
      } else {
        this.state.buttonNotifier = false;
      }
    }

    if (ReasonsBlock.length != 0) {
      this.state.reasons = ReasonsBlock.reasons;
      this.state.arrayUsers = InfoUsers;
    }

    var voz = false;

    if (InfoUsers.user_midias) {
      for (var i = 0; i < InfoUsers.user_midias.length; i++) {
        if (InfoUsers.user_midias[i] === 1) voz = true;
      }
    }

    if (localStorage.getItem("position-popup")) {
      this.state.popupValue = JSON.parse(
        localStorage.getItem("position-popup"),
      );
      // this.setState({
      //   popupValue: JSON.parse(localStorage.getItem("position-popup")),
      // });
    }

    return (
      <header className="header-main">
        <div className={this.state.modallivre}>
          <div className="modal-box">
            <div className="modal-box__header">
              <p className="modal-box__title">Fazer logout</p>
              <span className="modal-box__close-btn btn-close__logout">
                <i
                  onClick={(event) => this.CloseModal("modallivre")}
                  className="material-icons modal-box__close-icon"
                >
                  close
                </i>
              </span>
            </div>
            <div className="modal-box__content">
              <img src={SAIRLIVRE} alt="" className="modal-box__img" />
              <h3 className="modal-box__warning adjusted-19 is-poppins pd-0 mg-bottom-0">
                Você está livre para atender.
              </h3>
              <h3 className="modal-box__warning is-poppin is-poppins--bold pd-0 mg-top-0">
                Deseja mesmo sair?
              </h3>
              <p className="modal-box__message">
                Os clientes estão na fila esperando por você.
                <br />
                Se o seu expediente encerrou, selecione a pausa correspondente e
                faça o logout outra vez.
              </p>
              <a
                onClick={(event) => this.CloseModal("modallivre")}
                className="modal-box__return-btn btn-return__livre"
              >
                Retornar ao atendimento
              </a>
            </div>
          </div>
        </div>
        <div className={this.state.modalatendimento}>
          <div className="modal-box">
            <div className="modal-box__header">
              <p className="modal-box__title">Fazer logout</p>
              <span className="modal-box__close-btn btn-close__logout">
                <i
                  onClick={(event) => this.CloseModal("modalatendimento")}
                  className="material-icons modal-box__close-icon"
                >
                  close
                </i>
              </span>
            </div>
            <div className="modal-box__content">
              <img src={EMATENDIMENTO} alt="" className="modal-box__img" />
              <h3 className="modal-box__warning is-poppins">
                Atenção! Você ainda{" "}
                <em className="is-poppins is-poppins--bold">
                  está em atendimento.
                </em>
              </h3>
              <p className="modal-box__message">
                Interrompê-lo pode deixar o seu cliente insatisfeito. Primeiro,
                finalize o atendimento e então escolha uma pausa para poder
                efetuar o logout.
              </p>
              {(() => {
                if (this.state.displayfuture === "pausa__futura-btn active") {
                  const filterpauses = this.parametrosBlockFuture.value;
                  const parametros = filterpauses.split("|");
                  if (parametros[4] === "true") {
                    return (
                      <a
                        onClick={(event) =>
                          this.LogoutOut(
                            event,
                            InfoUsers,
                            ServiceID,
                            StatusAgent,
                            ServiceURL,
                          )
                        }
                        className="modal-box__return-btn btn-return__em-atendimento"
                      >
                        Sair mesmo assim
                      </a>
                    );
                  } else {
                    return (
                      <a
                        onClick={(event) => this.CloseModal("modalatendimento")}
                        className="modal-box__return-btn btn-return__pausa-errada"
                      >
                        Retornar ao atendimento
                      </a>
                    );
                  }
                } else {
                  return (
                    <a
                      onClick={(event) => this.CloseModal("modalatendimento")}
                      className="modal-box__return-btn btn-return__pausa-errada"
                    >
                      Retornar ao atendimento
                    </a>
                  );
                }
              })()}
            </div>
          </div>
        </div>
        <div className={this.state.modalpausado}>
          <div className="modal-box">
            <div className="modal-box__header">
              <p className="modal-box__title">Fazer logout</p>
              <span className="modal-box__close-btn btn-close__logout">
                <i
                  onClick={(event) => this.CloseModal("modalpausado")}
                  className="material-icons modal-box__close-icon"
                >
                  close
                </i>
              </span>
            </div>
            <div className="modal-box__content">
              <img src={PAUSAERRADA} alt="" className="modal-box__img" />
              <h3 className="modal-box__warning is-poppins pd-0">
                Oops… parece que você{" "}
                <em className="is-poppins is-poppins--bold">
                  não está na pausa correta.
                </em>
              </h3>
              <p className="modal-box__message">
                Se o seu expediente finalizou ou deseja apenas reiniciar o
                sistema, escolha a pausa correspondente antes de realizar o
                logout.
              </p>
              <a
                onClick={(event) => this.CloseModal("modalpausado")}
                className="modal-box__return-btn btn-return__pausa-errada"
              >
                Retornar ao atendimento
              </a>
            </div>
          </div>
        </div>
        <div className={this.state.modallogout} style={{ zIndex: 999 }}>
          <div className="modal-box modal-box--small">
            <div className="modal-box__header">
              <p className="modal-box__title">Fazer logout</p>
              {/* <span className="modal-box__close-btn btn-close__logout">
                <i
                  onClick={(event) => this.CloseModal("modallogout")}
                  className="material-icons modal-box__close-icon"
                >
                  close
                </i>
              </span> */}
            </div>
            <div className="modal-box__content">
              {/* <img src="build/images/logout.png" alt="" className="modal-box__img"> */}
              <h3 className="modal-box__warning is-poppins">
                Tem certeza que deseja{" "}
                <em className="is-poppins is-poppins--bold">sair do IngWeb?</em>
              </h3>
              <p className="modal-box__message modal-box__message--narrow">
                Para reinício do sistema, saia do sistema e efetue o login outra
                vez. <br />
                Se o seu expediente encerrou, até a próxima!
              </p>
              <div
                className="filters-dashboard-container-tag"
                style={{ paddingTop: "12px" }}
              >
                <SelectTagV2
                  valueTag={this.state.reasonLogoutSelected}
                  options={this.state.reasons
                    .filter((reason) => reason.logout === true)
                    .map((reason) => ({ ...reason, label: reason.name }))}
                  onSelect={(reason) => {
                    this.InsertPause(
                      "",
                      InfoUsers,
                      datalogin,
                      reason.name,
                      reason.id,
                      "BQ",
                      reason.logout,
                      reason.isdescription,
                      reason.allow_use,
                      StatusAgent,
                      reason.durationmaxblock,
                      reason.durationminblock,
                      ContactId,
                    );
                    this.setState({ reasonLogoutSelected: [reason] });
                  }}
                  multiple={false}
                  isCallCenter={true}
                  isChipActive={false}
                />
              </div>
              <a
                onClick={(event) =>
                  this.LogoutOut(
                    event,
                    InfoUsers,
                    ServiceID,
                    StatusAgent,
                    ServiceURL,
                  )
                }
                className="modal-box__default-btn modal-box__default-btn--left btn-return__logout"
              >
                Sair
              </a>
              <a
                onClick={(event) => {
                  // const hasAtd =
                  //   !!AtdSimult &&
                  //   Array.isArray(AtdSimult) &&
                  //   AtdSimult.length > 0;
                  // if (!hasAtd) {
                  //   this.InsertPause(
                  //     event,
                  //     InfoUsers,
                  //     datalogin,
                  //     "Livre",
                  //     "-1",
                  //     "LV",
                  //     "false",
                  //     false,
                  //     true,
                  //     StatusAgent,
                  //     0,
                  //     null,
                  //     ContactId
                  //   );
                  // }
                  return this.CloseModal("modallogout");
                }}
                className="modal-box__default-btn modal-box__default-btn--white modal-box__default-btn--right btn-return__logout"
              >
                Cancelar
              </a>
            </div>
          </div>
        </div>
        <div className={this.state.modaljustificado}>
          <div className="modal-box">
            <div className="modal-box__header">
              <p className="modal-box__title">Pausa - {this.state.pauseJust}</p>
              <span className="modal-box__close-btn btn-close__pausa-justificada">
                <i
                  onClick={(event) => this.CloseModal("modaljustificado")}
                  className="material-icons modal-box__close-icon"
                >
                  close
                </i>
              </span>
            </div>
            <div className="modal-box__content">
              {/* <img src="build/images/livre.png" alt="" className="modal-box__img"> */}
              <h3 className="modal-box__warning adjusted-19 is-poppins">
                Deseja fazer uma pausa?
              </h3>
              <p className="modal-box__message">
                Justifique ao gestor preenchendo o campo abaixo.
              </p>
              <textarea
                className="modal-box__textarea"
                ref={(input) => (this.textInput = input)}
                name="modal-box-text"
                id="modal-box-text"
              ></textarea>
              <div
                style={{
                  display: this.state.justificativabranco,
                  color: "red",
                }}
                className="invalid-feedback"
              >
                <b>Informe a Razão da Pausa!</b>
              </div>
              <a
                onClick={(event) =>
                  this.ReasonJustified(
                    event,
                    InfoUsers,
                    datalogin,
                    this.state.reasonname,
                    "BQ",
                    this.state.reasonid,
                    this.state.reasonlogout,
                    "true",
                    this.state.tempPause,
                    this.state.allowuse,
                    this.state.timemaxpause,
                    this.state.timeminpause,
                    ContactId,
                  )
                }
                className="modal-box__default-btn modal-box__default-btn--left btn-return__pausa-justificada"
              >
                Confirmar
              </a>
              <a
                onClick={(event) => this.CloseModal("modaljustificado")}
                className="modal-box__default-btn modal-box__default-btn--white modal-box__default-btn--right btn-return__pausa-justificada"
              >
                Cancelar
              </a>
            </div>
          </div>
        </div>
        <div className={this.state.modalsenha}>
          <div className="modal-box modal-box--medium">
            <div className="modal-box__header">
              <p className="modal-box__title">
                Pausa - {this.state.reasonname}
              </p>
              <span className="modal-box__close-btn btn-close__ret-pausa">
                <i
                  onClick={(event) => this.CloseModal("modalsenha")}
                  className="material-icons modal-box__close-icon"
                >
                  close
                </i>
              </span>
            </div>
            <div className="modal-box__content">
              {/* <img src="build/images/logout.png" alt="" className="modal-box__img"> */}
              <h3 className="modal-box__warning is-poppins">
                Atenção! Você precisa{" "}
                <em className="is-poppins is-poppins--bold">
                  de permissão para encerrar essa pausa.
                </em>
              </h3>
              <p className="modal-box__message">
                Digite a sua senha para retornar ao atendimento.
              </p>
              <div
                style={{ display: this.state.senhaincorreta, color: "red" }}
                className="invalid-feedback"
              >
                <b>Senha incorreta!</b>
              </div>
              <input
                type="hidden"
                id="armazenapausa"
                name="armazenapausa"
                ref={(input) => (this.parametrosInput = input)}
              />
              <input
                type="password"
                id="password"
                name="password"
                ref={(input) => (this.passwInput = input)}
                className="modal-box__input modal-box__input--password"
              />
              <a
                onClick={(event) =>
                  this.handleModalPassword(
                    event,
                    InfoUsers.password,
                    InfoUsers,
                    StatusAgent,
                  )
                }
                className="modal-box__default-btn modal-box__default-btn--left btn-return__ret-pausa"
              >
                Sair
              </a>
              <a
                onClick={(event) => this.CloseModal("modalsenha")}
                className="modal-box__default-btn modal-box__default-btn--white modal-box__default-btn--right btn-return__ret-pausa modal-box__close-btn"
              >
                Cancelar
              </a>
            </div>
          </div>
        </div>
        <div className="col-logo responsive">
          {/* <button onClick={event => this.props.ShowInfoDisplay2(event)}>trsssssestes</button> */}
          <div className="logo">
            {/* <Logo /> */}
            <img src={logoCarregada} alt="IngWeb" />
            <span>Developed by Ingenium Systems</span>
          </div>
        </div>
        <input
          type="hidden"
          id="armazenapausafutura"
          name="armazenapausafutura"
          ref={(input) => (this.parametrosBlockFuture = input)}
        />

        {/* <input type="text" id="valorramal" name="valorramal"  />
  <input type="text" id="valorjson" name="valorjson"  />
  <button type="button" onClick={event => this.ButtonClickSenChatSIP()}>OK</button> */}

        <div className="col-info-general responsive">
          <div className="col-center modified">
            <div className="status-pausa">
              <Popover
                trigger="click"
                placement="bottom"
                interactive={true}
                onShow={this.DisplayBlocks.bind(this)}
                onHide={this.DisplayBlocks.bind(this)}
                content={this.renderPopoverStatus(
                  InfoUsers,
                  StatusAgent,
                  ContactId,
                  AtdSimult,
                )}
                theme="ingweb header-ingweb"
              >
                <button
                  ref={(elemento) => {
                    this.meuElemento = elemento;
                  }}
                  className="pausa-btn active"
                >
                  {(() => {
                    if (!InfoUsers.enablecallvoz && voz) {
                      return (
                        <>
                          <span className="pausa-btn__icon pausa-btn--inativo"></span>
                          <span className="pausa-btn__info">
                            <span className="pausa-btn__text">
                              Registrando SIP •{" "}
                            </span>
                            {/* <p className="pausa-btn__timer">{this.state.timeOn}</p> */}
                            <span className="pausa-btn__timer">
                              &nbsp;{" "}
                              <TimeCounter key={"statusinativo"} horario={0} />
                            </span>
                          </span>
                          <ArrowDown
                            className={`pausa-btn__icon-svg ${
                              this.state.buttonActive ? "icon-active" : ""
                            }`}
                          />
                        </>
                      );
                    } else if (
                      StatusAgent.status === "Atendimento" ||
                      StatusAgent.status === "Ligação" ||
                      StatusAgent.status === "Chamando" ||
                      StatusAgent.status === "ChamandoChat" ||
                      StatusAgent.status === "Discando"
                    ) {
                      return (
                        <>
                          <span className="pausa-btn__icon pausa-btn--chmd-ativa"></span>
                          <span className="pausa-btn__info">
                            <span className="pausa-btn__text">
                              Interação Ativa •{" "}
                            </span>
                            {this.state.atdsimult.map((simult, index) => {
                              var dataatual = Moment().format(
                                "YYYY/MM/DD HH:mm:ss",
                              );

                              var valorDiferenca = parseInt(
                                Math.abs(Math.round(IPCurrent.difftime)),
                              );

                              if (parseInt(IPCurrent.difftime) < 0) {
                                dataatual = Moment()
                                  .subtract(valorDiferenca, "seconds")
                                  .format("YYYY/MM/DD HH:mm:ss");
                              } else {
                                dataatual = Moment()
                                  .add(valorDiferenca, "seconds")
                                  .format("YYYY/MM/DD HH:mm:ss");
                              }

                              var datatimeatd = Moment(
                                simult.recuperationtime,
                                "DD/MM/YYYY HH:mm:ss",
                              ).format("YYYY/MM/DD HH:mm:ss");

                              var time = Moment(dataatual).diff(
                                datatimeatd,
                                "seconds",
                              );

                              // time = parseInt(time)+(Math.round(IPCurrent.difftime))
                              if (time < 0) {
                                time = 0;
                              }
                              return (
                                <span
                                  key={simult.idatendimento}
                                  className="pausa-btn__timer"
                                  style={{
                                    display:
                                      parseInt(simult.idatendimento) ===
                                      parseInt(ContactId.idatendimento)
                                        ? "block"
                                        : "none",
                                  }}
                                >
                                  &nbsp;{" "}
                                  <TimeCounter
                                    key={
                                      simult.idatendimento +
                                      simult.recuperationtime
                                    }
                                    horario={time}
                                  />
                                </span>
                              );
                            })}
                          </span>
                          <ArrowDown
                            className={`pausa-btn__icon-svg ${
                              this.state.buttonActive ? "icon-active" : ""
                            }`}
                          />
                        </>
                      );
                    } else if (StatusAgent.status === "Aftercallwork") {
                      let timeAcw = 0;
                      return (
                        <>
                          {this.state.atdsimult
                            .filter(
                              (atd) =>
                                parseInt(atd.idatendimento) ===
                                parseInt(ContactId.idatendimento),
                            )
                            .map((simult, index) => {
                              try {
                                if (simult.acw === true) {
                                  timeAcw = Moment().diff(
                                    simult.hourAcw,
                                    "seconds",
                                  );
                                }
                              } catch (error) {
                                timeAcw = 0;
                              }
                              return (
                                <>
                                  <span className="pausa-btn__icon pausa-btn--after-call"></span>
                                  <span className="pausa-btn__info">
                                    <span className="pausa-btn__text">
                                      After Call Work •
                                    </span>
                                    <span className="pausa-btn__timer">
                                      &nbsp;{" "}
                                      <TimeCounter
                                        key={"statusconsulta"}
                                        horario={timeAcw}
                                      />
                                    </span>
                                  </span>
                                  <ArrowDown
                                    className={`pausa-btn__icon-svg ${
                                      this.state.buttonActive
                                        ? "icon-active"
                                        : ""
                                    }`}
                                  />
                                </>
                              );
                            })}
                        </>
                      );
                    } else if (
                      StatusAgent.status === "Pausado" ||
                      StatusAgent.status === "Logout"
                    ) {
                      return (
                        <>
                          <span className="pausa-btn__icon pausa-btn--pausado"></span>
                          <span className="pausa-btn__info">
                            <span className="pausa-btn__text">Pausado • </span>
                            {/* <p className="pausa-btn__timer">{this.state.timeOn}</p> */}
                            <span className="pausa-btn__timer">
                              &nbsp;{" "}
                              <TimeCounter
                                key={this.state.cleartime}
                                max={this.state.timemaxpause}
                                status={"Pausado"}
                                horario={0}
                                iduser={InfoUsers.id}
                              />
                            </span>
                            <span className="pausa-btn__text">- {status}</span>
                          </span>
                          <ArrowDown
                            className={`pausa-btn__icon-svg ${
                              this.state.buttonActive ? "icon-active" : ""
                            }`}
                          />
                        </>
                      );
                    } else if (StatusAgent.status === "Inativo") {
                      return (
                        <>
                          <span className="pausa-btn__icon pausa-btn--inativo"></span>
                          <span className="pausa-btn__info">
                            <span className="pausa-btn__text">Inativo • </span>
                            {/* <p className="pausa-btn__timer">{this.state.timeOn}</p> */}
                            <span className="pausa-btn__timer">
                              &nbsp;{" "}
                              <TimeCounter key={"statusinativo"} horario={0} />
                            </span>
                          </span>
                          <ArrowDown
                            className={`pausa-btn__icon-svg ${
                              this.state.buttonActive ? "icon-active" : ""
                            }`}
                          />
                        </>
                      );
                    } else if (StatusAgent.status === "Consulta") {
                      return (
                        <>
                          <span className="pausa-btn__icon pausa-btn--consulta"></span>
                          <span className="pausa-btn__info">
                            <span className="pausa-btn__text">Consulta • </span>
                            {/* <p className="pausa-btn__timer">{this.state.timeOn}</p> */}
                            <span className="pausa-btn__timer">
                              &nbsp;{" "}
                              <TimeCounter key={"statusconsulta"} horario={0} />
                            </span>
                          </span>
                          <ArrowDown
                            className={`pausa-btn__icon-svg ${
                              this.state.buttonActive ? "icon-active" : ""
                            }`}
                          />
                        </>
                      );
                    } else {
                      return (
                        <>
                          <span className="pausa-btn__icon pausa-btn--livre"></span>
                          <span className="pausa-btn__info">
                            <span className="pausa-btn__text">Livre • </span>
                            <span className="pausa-btn__timer">
                              &nbsp;{" "}
                              <TimeCounter key={"statuslivre"} horario={0} />
                            </span>
                          </span>
                          <ArrowDown
                            className={`pausa-btn__icon-svg ${
                              this.state.buttonActive ? "icon-active" : ""
                            }`}
                          />
                        </>
                      );
                    }
                  })()}
                </button>
              </Popover>
            </div>
            {/* <div className="pausa">
              <button
                onClick={this.DisplayBlocks.bind(this)}
                className={
                  this.state.buttonActive
                    ? "pausa__select-btn active"
                    : "pausa__select-btn"
                }
              >
                {InfoUsers.blockscreen ? "Bloqueado" : status}
                <i className="material-icons">chevron_right</i>
              </button>
            </div> */}
            {/* <button
              className={
                StatusAgent.afterStatus === "Pausado" &&
                StatusAgent.status !== "Pausado" &&
                StatusAgent.status !== "Logout"
                  ? "pausa__futura-btn active"
                  : this.state.displayfuture
              }
              onClick={(event) =>
                this.BreakBlockFuture(event, InfoUsers, ContactId)
              }
            >
              <span className="pausa__futura-btn-dot"></span>
              <FuturePauseIcon />
              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
                <path d="M0 0h24v24H0z" fill="none" />
              </svg> 
            </button> */}
          </div>

          <div className="col-right">
            <Tooltippy content="Ao clicar você cancela a sua pausa futura.">
              <button
                className={
                  StatusAgent.afterStatus === "Pausado" &&
                  StatusAgent.status !== "Pausado" &&
                  StatusAgent.status !== "Logout"
                    ? "pausa__futura-btn active"
                    : this.state.displayfuture
                }
                id="button_future_break"
                onClick={(event) =>
                  this.BreakBlockFuture(event, InfoUsers, ContactId)
                }
              >
                <div className="pausa__futura__new-container-icon">
                  <span className="pausa__futura-btn-dot"></span>
                  <FuturePauseIcon />
                </div>
                {/* <div className="pausa__futura-btn__text">Pausa futura</div> */}
                <div className="pausa__futura-btn__text">
                  {this.state.reasonname
                    ? this.state.reasonname
                    : "Pausa futura"}
                </div>
                <div className="pausa__futura-btn__text">
                  <TimeCounterFuture key={this.state.reasonname} horario={0} />
                </div>
              </button>
            </Tooltippy>
            {(() => {
              if (InfoUsers.enablecallvoz && voz && InfoUsers.allowcallpickup) {
                return (
                  <div className="col-calling">
                    <Tooltippy content={"Capturar Chamada"}>
                      <a
                        className=" tippy-default"
                        data-tippy-content="Capturar Chamada"
                        onClick={(event) => this.CaptureCall(event, InfoUsers)}
                      >
                        <CallIncomingIcon />
                      </a>
                    </Tooltippy>
                  </div>
                );
              }
            })()}
            <PopoverNotifier
              trigger="click"
              interactive={true}
              theme="ingweb header-ingweb"
              content={this.renderPopoverSettings(
                this,
                IPCurrent,
                this.state.registernotifier,
                CurrentScreen.previous,
                DeviceList,
                DeviceListDefault,
              )}
            >
              <div className="col-settings">
                <SettingsIcon />
              </div>
            </PopoverNotifier>

            <PopoverNotifier
              trigger="click"
              interactive={true}
              theme="ingweb header-ingweb col-notificantion-new"
              content={this.renderPopoverNotifier(
                this,
                IPCurrent,
                this.state.registernotifier,
                CurrentScreen.previous,
                DeviceList,
                DeviceListDefault,
              )}
            >
              <div
                className={
                  this.state.registernotifier.length != 0
                    ? "col-notifications has-notification"
                    : "col-notifications"
                }
              >
                <div className="col-notifications__new">
                  <div className="col-notifications__new__counter">
                    {this.state.tamanho}
                  </div>
                </div>
                <NotificationIcon />
                {/* <i className="material-icons">notifications</i> */}
              </div>
            </PopoverNotifier>
            {/* <div className="col-logout">
              <Tooltippy content={"Logout"}>
                <a
                  onClick={(event) =>
                    this.FuncLogoutIn(event, InfoUsers, ServiceID, StatusAgent)
                  }
                  className="logout btn btn-outline"
                >
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 19.219 19.186"
                  >
                    <path
                      fill="#748998"
                      d="M13.584 14.542a.678.678 0 0 0 .958 0l4.462-4.462a.438.438 0 0 0 .083-.1.058.058 0 0 0 .017-.033.361.361 0 0 1 .05-.083c0-.017 0-.033.017-.033.017-.033.017-.05.033-.083a.537.537 0 0 0 0-.264.126.126 0 0 0-.033-.083c0-.017 0-.033-.017-.033l-.05-.1a.016.016 0 0 0-.017-.017.438.438 0 0 0-.083-.1l-4.462-4.456a.678.678 0 0 0-.958.958l3.305 3.305H5.14a.678.678 0 1 0 0 1.355h11.749l-3.305 3.305a.639.639 0 0 0 0 .925z"
                    ></path>
                    <path
                      fill="#748998"
                      d="M.678 19.186H9.6a.67.67 0 0 0 .678-.678v-6.66a.678.678 0 0 0-1.355 0v5.982H1.355V1.355h7.568v5.982a.678.678 0 1 0 1.355 0V.678A.67.67 0 0 0 9.6 0H.678A.67.67 0 0 0 0 .678v17.83a.691.691 0 0 0 .678.678z"
                    ></path>
                  </svg>
                </a>
              </Tooltippy>
              <a
                href="/"
                style={{ display: "none" }}
                id="logoutclicado"
                className="logout btn btn-outline"
              >
                SAIR
              </a>
            </div> */}
          </div>
          <Popover
            onShow={this.DisplayBlocks2.bind(this)}
            onHide={this.DisplayBlocks2.bind(this)}
            trigger="click"
            placement="bottom-end"
            interactive={true}
            zIndex={9998}
            theme="ingweb header-ingweb"
            content={
              <div className="user-container">
                <div className="user-infos_picture">
                  <div className="infos-picture-main">
                    <UserPhoto size="huge" />

                    <div className="infos-user">
                      <div className="user-name">{InfoUsers.displayname}</div>
                      <div className="user-ramal">
                        Ramal: <span className="ramal">{InfoUsers.ramal}</span>
                      </div>
                      <div className="user-group">
                        Grupo: <span className="group">{InfoUsers.grupo}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="user-actions">
                  <ul>
                    {/* <li>
                      <div className="user-actions_icon">
                        <ChangePictureIcon />
                      </div>
                      <div className="user-actions_text">Alterar foto</div>
                    </li> */}
                    {/* <li>
                      <div className="user-actions_icon">
                        <ChangeUsernameIcon />
                      </div>
                      <div className="user-actions_text">Adicionar apelido</div>
                    </li> */}
                    {!connection_platform.azure_auth && (
                      <li onClick={(e) => this.DisplayModal(e, "modalactions")}>
                        <div className="user-actions_icon">
                          <ChangePasswordIcon />
                        </div>
                        <div className="user-actions_text">Alterar senha</div>
                      </li>
                    )}
                    <li
                      onClick={(event) => {
                        // this.FuncLogoutIn(
                        //   event,
                        //   InfoUsers,
                        //   ServiceID,
                        //   StatusAgent
                        // )
                        this.FuncLogoutInV2(
                          event,
                          InfoUsers,
                          ServiceID,
                          StatusAgent,
                          ContactId,
                        );
                      }}
                    >
                      <div className="user-actions_icon logout-action">
                        <LogoutIcon />
                      </div>
                      <div className="user-actions_text logout-action">
                        Sair da conta
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            }
          >
            <div className="col-user-info">
              <UserPhoto onClick={(event) => this.showUserMidia(event)} />
              {/* <div
                className="user-photo"
                onClick={(event) => this.showUserMidia(event)}
              >
                <img src={CLIENTE} alt="" />
              </div> */}
              <div className="user-name">
                {InfoUsers.displayname} • Ramal: {InfoUsers.ramal}
              </div>
              <ArrowDown
                className={`pausa-btn__icon-svg ${
                  this.state.buttonActive2 ? "icon-active" : ""
                }`}
              />
            </div>
            {this.state.loading && <MountTabulator />}
          </Popover>
        </div>

        <div
          className={this.state.modalactions}
          // onClick={(e) => {
          //   e.stopPropagation();
          //   this.CloseModal(e, "modalactions");
          // }}
        >
          <div className="modal-box">
            <div className="modal-box__header">
              <h1>Alterar senha</h1>
            </div>
            <div className="modal-box__content">
              <form action="" onSubmit={(e) => this.changePassword(e, this)}>
                <div className="principal-form">
                  <div className="form-inputs">
                    <div className="field-container field-password">
                      <span className="field-container__title">
                        Senha atual
                      </span>
                      <div className="input-container">
                        <input
                          type={
                            this.state.changeTypePassword1 ? "password" : "text"
                          }
                          value={this.state.valuePasswords.password}
                          onChange={(e) => this.handleChange(e, "password")}
                          name="current_password"
                          id="current_password"
                          placeholder="Senha atual"
                        />
                        {this.state.changeTypePassword1 ? (
                          <EyeIcon onClick={() => this.handleTypePassword(1)} />
                        ) : (
                          <EyeSlashIcon
                            onClick={() => this.handleTypePassword(1)}
                          />
                        )}
                      </div>
                      <span
                        id="msg_erro1"
                        className="field-container__aviso"
                      ></span>
                    </div>
                    <div className="field-container field-passwordNew">
                      <span className="field-container__title">Nova senha</span>
                      <div className="input-container">
                        <input
                          type={
                            this.state.changeTypePassword2 ? "password" : "text"
                          }
                          value={this.state.valuePasswords.passwordNew}
                          onChange={(e) => this.handleChange(e, "passwordNew")}
                          name="new_password"
                          id="new_password"
                          placeholder="Nova senha"
                        />
                        {this.state.changeTypePassword2 ? (
                          <EyeIcon onClick={() => this.handleTypePassword(2)} />
                        ) : (
                          <EyeSlashIcon
                            onClick={() => this.handleTypePassword(2)}
                          />
                        )}
                      </div>
                      <span
                        id="msg_erro2"
                        className="field-container__aviso"
                      ></span>
                    </div>
                    <div className="field-container field-passwordNewConfirm">
                      <span className="field-container__title">
                        Confirmar nova senha
                      </span>
                      <div className="input-container">
                        <input
                          type={
                            this.state.changeTypePassword3 ? "password" : "text"
                          }
                          value={this.state.valuePasswords.passwordNewRep}
                          onChange={(e) =>
                            this.handleChange(e, "passwordNewRep")
                          }
                          name="new_password_repeat"
                          id="new_password_repeat"
                          placeholder="Repita a nova senha"
                        />
                        {this.state.changeTypePassword3 ? (
                          <EyeIcon onClick={() => this.handleTypePassword(3)} />
                        ) : (
                          <EyeSlashIcon
                            onClick={() => this.handleTypePassword(3)}
                          />
                        )}
                      </div>
                      <span
                        id="msg_erro3"
                        className="field-container__aviso"
                      ></span>
                    </div>
                  </div>
                  <img
                    src={ResetPassword}
                    alt="Desenho de um homem segurando uma chave pra abrir um cadeado"
                  />
                </div>
                <div className="modal-box__footer">
                  <button
                    className="button_cancel"
                    onClick={(e) => this.CloseModal("modalactions")}
                  >
                    <span>Cancelar</span>
                  </button>
                  <button type="submit" className="button_save">
                    <span>Salvar</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <input type="hidden" id="simulation_click" name="simulation_click" />
        <input
          type="hidden"
          id="click_pause_automatic"
          name="click_pause_automatic"
          onClick={(e) => this.removePauseActive(e)}
        />
        <div
          className="modal micromodal-slide"
          id="modal__mensagem-equipe"
          aria-hidden="true"
          role="dialog"
        >
          <TeamModal />
        </div>
        <ToasterSecond
          // position="top-center"
          key="2"
          toastOptions={{
            // Define default options
            className: "toast_automatic_pause_disable",
            duration: Infinity,
            id: 1,
            style: {
              background: "#363636",
              color: "#fff",
            },
          }}
        />
        {AutomaticPause.length !== 0 && (
          <Automatic_pause
            insert_pause_automatic={this.insert_pause_automatic}
            pauses={AutomaticPause}
          />
        )}
        <AddUserMidia array={this.state.arrayusersmidias} />
        <div
          className="modal micromodal-slide"
          id="modal__notificacoes"
          aria-hidden="true"
          role="dialog"
        >
          <NotifierModal />
        </div>
        <div
          className={
            InfoUsers.blocknc2
              ? "modal-overlay modal__pausa-errada active"
              : "modal-overlay modal__pausa-errada"
          }
        >
          <div className="modal-box">
            <div className="modal-box__header">
              <h3 className="modal-box__warning is-poppins pd-0">
                <em className="is-poppins is-poppins--bold">
                  {InfoUsers.mensagemnc2}
                </em>
              </h3>
              {/* <span className="modal-box__close-btn btn-close__logout"><i className="material-icons modal-box__close-icon">close</i></span> */}
              <div className="col-logout">
                <Tooltippy content={"Logout"}>
                  <a
                    onClick={(event) =>
                      this.LogoutOut(
                        event,
                        InfoUsers,
                        ServiceID,
                        StatusAgent,
                        ServiceURL,
                      )
                    }
                    className="logout btn btn-outline"
                  >
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 19.219 19.186"
                    >
                      <path
                        fill="#748998"
                        d="M13.584 14.542a.678.678 0 0 0 .958 0l4.462-4.462a.438.438 0 0 0 .083-.1.058.058 0 0 0 .017-.033.361.361 0 0 1 .05-.083c0-.017 0-.033.017-.033.017-.033.017-.05.033-.083a.537.537 0 0 0 0-.264.126.126 0 0 0-.033-.083c0-.017 0-.033-.017-.033l-.05-.1a.016.016 0 0 0-.017-.017.438.438 0 0 0-.083-.1l-4.462-4.456a.678.678 0 0 0-.958.958l3.305 3.305H5.14a.678.678 0 1 0 0 1.355h11.749l-3.305 3.305a.639.639 0 0 0 0 .925z"
                      ></path>
                      <path
                        fill="#748998"
                        d="M.678 19.186H9.6a.67.67 0 0 0 .678-.678v-6.66a.678.678 0 0 0-1.355 0v5.982H1.355V1.355h7.568v5.982a.678.678 0 1 0 1.355 0V.678A.67.67 0 0 0 9.6 0H.678A.67.67 0 0 0 0 .678v17.83a.691.691 0 0 0 .678.678z"
                      ></path>
                    </svg>
                  </a>
                </Tooltippy>
                <a
                  href="/"
                  style={{ display: "none" }}
                  id="logoutclicado"
                  className="logout btn btn-outline"
                >
                  SAIR
                </a>
              </div>
            </div>
            <div className="modal-box__content">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTfQiQbbOcOXy7XEGHKRqZZzjyvmcPGL3sWPQ&usqp=CAU"
                alt=""
                className="modal-box__img"
              />
              <h3 className="modal-box__warning is-poppins pd-0">
                Oops…{" "}
                <em className="is-poppins is-poppins--bold">Agente em pausa</em>
              </h3>
              <a
                href="/login"
                style={{ display: "none" }}
                id="logoutclicado"
                className="logout btn btn-outline"
              >
                SAIR
              </a>
              {/* <p className="modal-box__message">
              Solicite ao seu gestor para efetue o desbloqueio de seu login
            </p> */}
              {/* <p className="modal-box__message">Razão do bloqueio: {InfoUsers.mensagemnc2}</p> */}
              <a
                onClick={(event) =>
                  this.ContinueSup(event, InfoUsers, StatusAgent)
                }
                className="modal-box__return-btn btn-return__pausa-errada"
              >
                Continuar
              </a>
            </div>
          </div>
        </div>

        {/* Ajuste temporario para contemplar pausas automaticas */}

        <div className={"pausa__select"}>
          <p className="pausa__list-title">Selecione um status</p>
          <ul className="pausa__list max-h">
            <li
              className={
                this.state.disabled ? "pausa__item active" : "pausa__item"
              }
              onClick={(event) =>
                this.InsertPause(
                  event,
                  InfoUsers,
                  datalogin,
                  "Livre",
                  "-1",
                  "LV",
                  "false",
                  false,
                  true,
                  StatusAgent,
                  0,
                  null,
                  ContactId,
                )
              }
            >
              <span className="pausa-btn__icon pausa-btn--livre"></span>
              <p className="pausa__label">
                {" "}
                {InfoUsers.blockscreen ? "Bloqueado" : "Livre"}
              </p>
            </li>
            {this.state.reasons.map((reason) =>
              (() => {
                if (reason.logout === false) {
                  return (
                    <li
                      key={reason.id}
                      id={`reason-${reason.id}`}
                      className={
                        this.state.buttonPauseDis &&
                        this.state.PausaId === reason.id
                          ? "pausa__item active"
                          : "pausa__item"
                      }
                      onClick={(event) => {
                        this.InsertPause(
                          event,
                          InfoUsers,
                          datalogin,
                          reason.name,
                          reason.id,
                          "BQ",
                          reason.logout,
                          reason.isdescription,
                          reason.allow_use,
                          StatusAgent,
                          reason.durationmaxblock,
                          reason.durationminblock,
                          ContactId,
                        );
                        this.setState({ reasonLogoutSelected: [] });
                      }}
                    >
                      <span className="pausa-btn__icon pausa-btn--pausado"></span>
                      <p className="pausa__label"> {reason.name}</p>
                    </li>
                  );
                }
              })(),
            )}
          </ul>
          <hr className="pausa__divider" />
          <ul className="pausa__list">
            {this.state.reasons.map((reason) =>
              (() => {
                if (reason.logout === true) {
                  return (
                    <li
                      key={reason.id}
                      className={
                        this.state.buttonPauseDis &&
                        this.state.PausaId === reason.id
                          ? "pausa__item active"
                          : "pausa__item"
                      }
                      onClick={(event) => {
                        this.InsertPause(
                          event,
                          InfoUsers,
                          datalogin,
                          reason.name,
                          reason.id,
                          "BQ",
                          reason.logout,
                          reason.isdescription,
                          reason.allow_use,
                          StatusAgent,
                          reason.durationmaxblock,
                          reason.durationminblock,
                          ContactId,
                        );
                        this.setState({
                          reasonLogoutSelected: [
                            { ...reason, label: reason.name },
                          ],
                        });
                      }}
                    >
                      <span className="pausa-btn__icon pausa-btn--pausado"></span>
                      <p className="pausa__label"> {reason.name}</p>
                    </li>
                  );
                }
              })(),
            )}
          </ul>
        </div>
        <ReconnectModal />
      </header>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InfoUser);
